<template>
  <div>
    <b-card
      no-body
      class="mb-2"
    >
      <b-card-body class="d-flex align-items-center py-1">
        <h4 class="mb-0">
          <feather-icon
            icon="TrendingUpIcon"
            size="20"
            class="text-primary mr-1"
          />
          Kazanç Stratejileri
        </h4>
        <b-button
          variant="primary"
          class="ml-auto"
          @click="newStrategy"
        >
          <feather-icon icon="PlusIcon" /> Yeni Strateji
        </b-button>
      </b-card-body>
    </b-card>

    <b-row>
      <b-col
        cols="12"
        lg="4"
        class="mb-2"
      >
        <b-card no-body>
          <b-card-body class="py-1">
            <b-form-input
              v-model="filter.search"
              placeholder="strateji ara..."
              @input="onSearchInput"
            />
          </b-card-body>
          <b-table
            :items="strategies"
            :fields="strategyFields"
            :busy="loading"
            small
            hover
            responsive
            show-empty
            empty-text="Henüz strateji yok."
          >
            <template #cell(name)="data">
              <a
                href="#"
                class="font-weight-bold"
                @click.prevent="selectStrategy(data.item)"
              >
                {{ data.item.name }}
              </a>
              <div class="font-small-2 text-muted">
                {{ formatNum(data.item.totalBudget, 0) }} USDT · {{ data.item.totalBots }} bot · {{ formatNum(data.item.leverage, 0) }}x
              </div>
              <b-badge
                v-if="data.item.isDefault"
                variant="light-primary"
                class="mt-50"
              >
                Default
              </b-badge>
            </template>
            <template #cell(actions)="data">
              <b-button
                size="sm"
                variant="outline-success"
                @click="openApply(data.item)"
              >
                <feather-icon icon="ZapIcon" /> Uygula
              </b-button>
            </template>
          </b-table>
        </b-card>
      </b-col>

      <b-col
        cols="12"
        lg="8"
      >
        <b-card no-body>
          <b-card-body v-if="form">
            <div class="d-flex align-items-center mb-1">
              <div>
                <h5 class="mb-0">
                  {{ form.id ? 'Strateji Düzenle' : 'Yeni Strateji' }}
                </h5>
                <small class="text-muted">Bütçe, profil dağılımı, TP/SL ve K/Z yönetimi</small>
              </div>
              <b-badge
                v-if="form.isDefault"
                variant="light-primary"
                class="ml-auto"
              >
                Default seed
              </b-badge>
            </div>

            <b-row>
              <b-col
                cols="12"
                md="6"
                class="mb-1"
              >
                <label class="font-small-3 text-muted">Strateji Adı</label>
                <b-form-input v-model="form.name" />
              </b-col>
              <b-col
                cols="6"
                md="3"
                class="mb-1"
              >
                <label class="font-small-3 text-muted">Toplam Bütçe</label>
                <b-form-input
                  v-model.number="form.totalBudget"
                  type="number"
                  min="0"
                  step="100"
                />
              </b-col>
              <b-col
                cols="6"
                md="3"
                class="mb-1"
              >
                <label class="font-small-3 text-muted">Toplam Bot</label>
                <b-form-input
                  v-model.number="form.totalBots"
                  type="number"
                  min="1"
                  step="1"
                />
              </b-col>
              <b-col
                cols="12"
                class="mb-1"
              >
                <label class="font-small-3 text-muted">Açıklama</label>
                <b-form-textarea
                  v-model="form.description"
                  rows="2"
                />
              </b-col>
              <b-col
                cols="6"
                md="3"
                class="mb-1"
              >
                <label class="font-small-3 text-muted">Mod</label>
                <b-form-select
                  v-model="form.mode"
                  :options="modeOptions"
                />
              </b-col>
              <b-col
                cols="6"
                md="3"
                class="mb-1"
              >
                <label class="font-small-3 text-muted">Market</label>
                <b-form-select
                  v-model="form.market"
                  :options="marketOptions"
                />
              </b-col>
              <b-col
                cols="6"
                md="3"
                class="mb-1"
              >
                <label class="font-small-3 text-muted">Edge Türü</label>
                <b-form-select
                  v-model="form.edgeKind"
                  :options="edgeKindOptions"
                />
              </b-col>
              <b-col
                cols="6"
                md="3"
                class="mb-1"
              >
                <label class="font-small-3 text-muted">Kaldıraç</label>
                <b-form-input
                  v-model.number="form.leverage"
                  type="number"
                  min="1"
                  step="1"
                />
              </b-col>
              <b-col
                cols="12"
                class="mb-1"
              >
                <div class="auto-calc-panel">
                  <b-row class="align-items-end">
                    <b-col
                      cols="12"
                      md="4"
                      class="mb-1 mb-md-0"
                    >
                      <b-form-checkbox
                        v-model="form.config.autoCalculation.enabled"
                        switch
                        @change="onAutoCalculationToggle"
                      >
                        <strong>Otomatik hesaplama</strong>
                      </b-form-checkbox>
                      <small class="text-muted d-block mt-50">{{ autoCalculationSummary }}</small>
                    </b-col>
                    <b-col
                      cols="6"
                      md="3"
                      class="mb-1 mb-md-0"
                    >
                      <label class="font-small-3 text-muted">Risk modu</label>
                      <b-form-select
                        v-model="form.config.autoCalculation.riskMode"
                        :options="riskModeOptions"
                        :disabled="!form.config.autoCalculation.enabled"
                        @change="onAutoCalcInputChange"
                      />
                    </b-col>
                    <b-col
                      cols="6"
                      md="3"
                      class="mb-1 mb-md-0"
                    >
                      <b-form-checkbox
                        v-model="form.config.autoCalculation.preserveManual"
                        :disabled="!form.config.autoCalculation.enabled"
                      >
                        Manuel TP/KZ değerlerini koru
                      </b-form-checkbox>
                    </b-col>
                    <b-col
                      cols="12"
                      md="2"
                      class="mb-1 mb-md-0"
                    >
                      <b-button
                        block
                        variant="outline-primary"
                        :disabled="!form.config.autoCalculation.enabled"
                        @click="applyAutoCalculation"
                      >
                        <feather-icon icon="SlidersIcon" /> Hesapla
                      </b-button>
                    </b-col>
                    <b-col
                      cols="12"
                      class="mt-1"
                    >
                      <b-button
                        variant="outline-info"
                        :disabled="profileChecking"
                        @click="runProfileCheck"
                      >
                        <b-spinner
                          v-if="profileChecking"
                          small
                        />
                        <feather-icon
                          v-else
                          icon="SearchIcon"
                        />
                        Profil kontrolü yap
                      </b-button>
                      <small class="text-muted ml-1">
                        Aktif edge son sonuçları ve açık pozisyon +/- durumu okunur; öneri onaylanmadan uygulanmaz.
                      </small>
                    </b-col>
                  </b-row>
                </div>
              </b-col>
              <b-col
                cols="12"
                class="mb-1"
              >
                <b-form-checkbox
                  v-model="form.config.targetSignalPoolEnabled"
                  switch
                >
                  <strong>bot müsait tüm edgeleri alabilsin.</strong>
                </b-form-checkbox>
              </b-col>
              <b-col
                cols="12"
                class="mb-1"
              >
                <b-form-checkbox
                  v-model="form.config.dailyProfitGivebackGuard.enabled"
                  switch
                >
                  <strong>Gün içi kâr geri verme koruması</strong>
                </b-form-checkbox>
                <b-row
                  v-if="form.config.dailyProfitGivebackGuard.enabled"
                  class="mt-1"
                >
                  <b-col
                    cols="6"
                    md="3"
                    class="mb-1"
                  >
                    <label class="font-small-3 text-muted">Silahlanma kârı USDT</label>
                    <b-form-input
                      v-model.number="form.config.dailyProfitGivebackGuard.minProfitToArmUsdt"
                      type="number"
                      min="0"
                      step="1"
                    />
                  </b-col>
                  <b-col
                    cols="6"
                    md="3"
                    class="mb-1"
                  >
                    <label class="font-small-3 text-muted">Max geri verme %</label>
                    <b-form-input
                      v-model.number="form.config.dailyProfitGivebackGuard.maxGivebackPercent"
                      type="number"
                      min="0"
                      max="100"
                      step="1"
                    />
                  </b-col>
                </b-row>
              </b-col>
              <b-col
                v-if="form.config.targetSignalPoolEnabled"
                cols="12"
                class="mb-1"
              >
                <b-card
                  no-body
                  class="border bg-light p-1"
                >
                  <strong class="mb-1 d-block">Pool kalite filtresi</strong>
                  <b-row>
                    <b-col
                      cols="6"
                      md="3"
                      class="mb-1"
                    >
                      <label class="font-small-3 text-muted">Pool max edge</label>
                      <b-form-input
                        v-model.number="form.config.targetSignalPoolFilters.maxEdges"
                        type="number"
                        min="1"
                        max="50"
                        step="1"
                      />
                    </b-col>
                    <b-col
                      cols="6"
                      md="3"
                      class="mb-1"
                    >
                      <label class="font-small-3 text-muted">Min score</label>
                      <b-form-input
                        v-model.number="form.config.targetSignalPoolFilters.minScoreFinal"
                        type="number"
                        step="0.01"
                      />
                    </b-col>
                    <b-col
                      cols="6"
                      md="3"
                      class="mb-1"
                    >
                      <label class="font-small-3 text-muted">Min WR %</label>
                      <b-form-input
                        v-model.number="form.config.targetSignalPoolFilters.minWinRate"
                        type="number"
                        min="0"
                        max="100"
                        step="1"
                      />
                    </b-col>
                    <b-col
                      cols="6"
                      md="3"
                      class="mb-1"
                    >
                      <label class="font-small-3 text-muted">Min net EV</label>
                      <b-form-input
                        v-model.number="form.config.targetSignalPoolFilters.minNetEv"
                        type="number"
                        step="0.01"
                      />
                    </b-col>
                    <b-col
                      cols="6"
                      md="3"
                      class="mb-1"
                    >
                      <label class="font-small-3 text-muted">Min trade</label>
                      <b-form-input
                        v-model.number="form.config.targetSignalPoolFilters.minTrades"
                        type="number"
                        min="0"
                        step="1"
                      />
                    </b-col>
                    <b-col
                      cols="6"
                      md="3"
                      class="mb-1"
                    >
                      <label class="font-small-3 text-muted">MFE örnek</label>
                      <b-form-input
                        v-model.number="form.config.targetSignalPoolFilters.minMfeSamples"
                        type="number"
                        min="0"
                        step="1"
                      />
                    </b-col>
                    <b-col
                      cols="6"
                      md="3"
                      class="mb-1"
                    >
                      <label class="font-small-3 text-muted">+0,50 MFE %</label>
                      <b-form-input
                        v-model.number="form.config.targetSignalPoolFilters.minMfe50Rate"
                        type="number"
                        min="0"
                        max="100"
                        step="1"
                      />
                    </b-col>
                    <b-col
                      cols="6"
                      md="3"
                      class="mb-1"
                    >
                      <label class="font-small-3 text-muted">+0,75 MFE %</label>
                      <b-form-input
                        v-model.number="form.config.targetSignalPoolFilters.minMfe75Rate"
                        type="number"
                        min="0"
                        max="100"
                        step="1"
                      />
                    </b-col>
                    <b-col
                      cols="6"
                      md="3"
                      class="mb-1"
                    >
                      <label class="font-small-3 text-muted">Avg MFE %</label>
                      <b-form-input
                        v-model.number="form.config.targetSignalPoolFilters.minAvgMfe"
                        type="number"
                        min="0"
                        step="0.01"
                      />
                    </b-col>
                    <b-col
                      cols="6"
                      md="3"
                      class="mb-1"
                    >
                      <label class="font-small-3 text-muted">Coin cooldown dk</label>
                      <b-form-input
                        v-model.number="form.config.targetSignalPoolFilters.symbolCooldownMinutes"
                        type="number"
                        min="0"
                        step="5"
                      />
                    </b-col>
                    <b-col
                      cols="6"
                      md="3"
                      class="mb-1"
                    >
                      <label class="font-small-3 text-muted">Aynı yön max açık</label>
                      <b-form-input
                        v-model.number="form.config.targetSignalPoolFilters.maxSameSideOpenPositions"
                        type="number"
                        min="0"
                        step="1"
                      />
                    </b-col>
                    <b-col
                      cols="12"
                      md="3"
                      class="mb-1 d-flex align-items-end"
                    >
                      <b-form-checkbox v-model="form.config.targetSignalPoolFilters.rejectLastExitSl">
                        Son işlem SL ise alma
                      </b-form-checkbox>
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
              <b-col
                cols="12"
                class="mb-1"
              >
                <b-card
                  no-body
                  class="border bg-light p-1"
                >
                  <b-form-checkbox
                    v-model="form.config.strategySafetyGovernor.enabled"
                    switch
                    class="mb-1"
                  >
                    <strong>Strateji güvenlik yöneticisi</strong> — risk kapalı olsa bile pozisyon boyunu ve kötüleşen giriş ailelerini otomatik frenler.
                  </b-form-checkbox>
                  <b-row v-if="form.config.strategySafetyGovernor.enabled">
                    <b-col
                      cols="6"
                      md="3"
                      class="mb-1"
                    >
                      <label class="font-small-3 text-muted">Risk kapalı max zarar</label>
                      <b-form-input
                        v-model.number="form.config.strategySafetyGovernor.maxRiskUsdtWhenRiskOff"
                        type="number"
                        min="0"
                        step="0.5"
                      />
                    </b-col>
                    <b-col
                      cols="6"
                      md="3"
                      class="mb-1"
                    >
                      <label class="font-small-3 text-muted">Risk kapalı max sermaye %</label>
                      <b-form-input
                        v-model.number="form.config.strategySafetyGovernor.maxCapitalUsagePercentWhenRiskOff"
                        type="number"
                        min="0"
                        max="100"
                        step="1"
                      />
                    </b-col>
                    <b-col
                      cols="6"
                      md="3"
                      class="mb-1"
                    >
                      <label class="font-small-3 text-muted">Family max loss rate</label>
                      <b-form-input
                        v-model.number="form.config.strategySafetyGovernor.familyMaxLossRate"
                        type="number"
                        min="0"
                        max="1"
                        step="0.05"
                      />
                    </b-col>
                    <b-col
                      cols="6"
                      md="3"
                      class="mb-1"
                    >
                      <label class="font-small-3 text-muted">Guardian loss max net</label>
                      <b-form-input
                        v-model.number="form.config.strategySafetyGovernor.guardianLossMaxNetUsdt"
                        type="number"
                        min="0"
                        step="5"
                      />
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
              <b-col
                cols="12"
                class="mb-1"
              >
                <b-card
                  no-body
                  class="border bg-light p-1"
                >
                  <b-form-checkbox
                    v-model="form.config.marketDirectionConsensus.enabled"
                    switch
                    class="mb-1"
                  >
                    <strong>Piyasa yönü onayı</strong> — diğer aktif edge sinyallerinin çoğunluğu aynı yöndeyse giriş yap.
                  </b-form-checkbox>
                  <b-row v-if="form.config.marketDirectionConsensus.enabled">
                    <b-col
                      cols="6"
                      md="2"
                      class="mb-1"
                    >
                      <label class="font-small-3 text-muted">Min sinyal</label>
                      <b-form-input
                        v-model.number="form.config.marketDirectionConsensus.minSignals"
                        type="number"
                        min="1"
                        max="100"
                        step="1"
                      />
                    </b-col>
                    <b-col
                      cols="6"
                      md="2"
                      class="mb-1"
                    >
                      <label class="font-small-3 text-muted">Aynı yön %</label>
                      <b-form-input
                        v-model.number="form.config.marketDirectionConsensus.requiredAgreementPercent"
                        type="number"
                        min="50"
                        max="100"
                        step="1"
                      />
                    </b-col>
                    <b-col
                      cols="6"
                      md="2"
                      class="mb-1"
                    >
                      <label class="font-small-3 text-muted">Tazelik (mum)</label>
                      <b-form-input
                        v-model.number="form.config.marketDirectionConsensus.freshnessBars"
                        type="number"
                        min="0.25"
                        max="10"
                        step="0.25"
                      />
                    </b-col>
                    <b-col
                      cols="6"
                      md="2"
                      class="mb-1"
                    >
                      <label class="font-small-3 text-muted">Kararlılık</label>
                      <b-form-input
                        v-model.number="form.config.marketDirectionConsensus.stabilityChecks"
                        type="number"
                        min="1"
                        max="10"
                        step="1"
                      />
                    </b-col>
                    <b-col
                      cols="12"
                      md="4"
                      class="mb-1"
                    >
                      <label class="font-small-3 text-muted">Yetersiz veri</label>
                      <b-form-select
                        v-model="form.config.marketDirectionConsensus.insufficientDataAction"
                        :options="consensusInsufficientOptions"
                      />
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
              <b-col
                cols="12"
                class="mb-1"
              >
                <b-card
                  no-body
                  class="border bg-light p-1"
                >
                  <div class="d-flex align-items-center mb-1">
                    <strong class="mb-0 d-block">Sinyal giriş kuralları</strong>
                    <b-button
                      size="sm"
                      variant="outline-primary"
                      class="ml-auto"
                      :disabled="entryPresetState.loading"
                      @click="refreshStrategyEntryPresets"
                    >
                      <b-spinner
                        v-if="entryPresetState.loading"
                        small
                      />
                      <feather-icon
                        v-else
                        icon="RefreshCwIcon"
                      />
                      Öneri yenile
                    </b-button>
                  </div>
                  <b-form-checkbox
                    v-model="entryPresetState.autoApplyEnabled"
                    switch
                    class="mb-1"
                    @change="onStrategyEntryAutoApplyChange"
                  >
                    Önerileri otomatik işle
                  </b-form-checkbox>
                  <div
                    v-if="entryPresetState.rows.length"
                    class="mb-1"
                  >
                    <div
                      v-for="(row, index) in entryPresetState.rows"
                      :key="row.preset.id"
                      class="border rounded bg-white px-1 py-50 mb-50"
                    >
                      <div class="d-flex align-items-center">
                        <div class="min-w-0">
                          <b-badge :variant="entryPresetVariant(row.severity)">
                            {{ entryPresetLabel(row.severity) }}
                          </b-badge>
                          <b-badge
                            v-if="index === 0"
                            variant="light-primary"
                            class="ml-50"
                          >
                            One cikan
                          </b-badge>
                          <b-badge
                            :variant="entryPresetScopeVariant(row.preset.scope)"
                            class="ml-50"
                          >
                            {{ entryPresetScopeLabel(row.preset.scope) }}
                          </b-badge>
                          <b-badge
                            v-if="isStrategyEntryPresetApplied(row)"
                            variant="light-success"
                            class="ml-50"
                          >
                            İşlendi
                          </b-badge>
                          <strong class="ml-50">{{ row.preset.label }}</strong>
                        </div>
                        <b-button
                          size="sm"
                          variant="outline-success"
                          class="ml-auto"
                          :disabled="isStrategyEntryPresetApplied(row)"
                          @click="applyStrategyEntryPreset(row)"
                        >
                          {{ isStrategyEntryPresetApplied(row) ? 'İşlendi' : "Draft'e işle" }}
                        </b-button>
                      </div>
                      <div class="font-small-3 text-muted mt-50">
                        {{ row.title }}
                      </div>
                      <div class="font-small-3 text-primary">
                        Neden onde: {{ row.priorityReason }}
                      </div>
                      <div class="font-small-3 text-muted">
                        Uygular: {{ row.actionSummary }}
                      </div>
                      <div class="font-small-3 text-muted">
                        Amaç: {{ row.recommendationShort }}
                      </div>
                      <div class="font-small-3 text-muted">
                        {{ row.patchCount }} patch · {{ row.preset.summary }}
                      </div>
                    </div>
                  </div>
                  <b-row>
                    <b-col
                      cols="6"
                      md="3"
                      class="mb-1"
                    >
                      <label class="font-small-3 text-muted">Onay bekleme</label>
                      <b-form-input
                        v-model.number="form.config.signalEntry.confirmationTicks"
                        type="number"
                        min="0"
                        max="5"
                        step="1"
                      />
                    </b-col>
                    <b-col
                      cols="6"
                      md="3"
                      class="mb-1"
                    >
                      <label class="font-small-3 text-muted">Maks sinyal yaşı</label>
                      <b-form-input
                        v-model.number="form.config.signalEntry.maxSignalAgeBars"
                        type="number"
                        min="0"
                        max="10"
                        step="1"
                      />
                    </b-col>
                    <b-col
                      cols="6"
                      md="3"
                      class="mb-1"
                    >
                      <label class="font-small-3 text-muted">Min lehe ilerleme %</label>
                      <b-form-input
                        v-model.number="form.config.signalEntry.minFavorableMovePct"
                        type="number"
                        min="0"
                        step="0.01"
                      />
                    </b-col>
                    <b-col
                      cols="6"
                      md="3"
                      class="mb-1"
                    >
                      <label class="font-small-3 text-muted">Maks kaçmış fiyat %</label>
                      <b-form-input
                        v-model.number="form.config.signalEntry.maxFavorableMovePct"
                        type="number"
                        min="0"
                        step="0.01"
                      />
                    </b-col>
                    <b-col
                      cols="6"
                      md="3"
                      class="mb-1"
                    >
                      <label class="font-small-3 text-muted">Maks ters sapma %</label>
                      <b-form-input
                        v-model.number="form.config.signalEntry.maxAdverseMovePct"
                        type="number"
                        min="0"
                        step="0.01"
                      />
                    </b-col>
                    <b-col
                      cols="12"
                      md="3"
                      class="mb-1 d-flex align-items-end"
                    >
                      <b-form-checkbox
                        v-model="form.config.signalEntry.routerEnabled"
                        switch
                      >
                        Giriş router
                      </b-form-checkbox>
                    </b-col>
                    <b-col
                      cols="6"
                      md="3"
                      class="mb-1"
                    >
                      <label class="font-small-3 text-muted">Min giriş skoru</label>
                      <b-form-input
                        v-model.number="form.config.signalEntry.minEntryScore"
                        type="number"
                        min="0"
                        max="1"
                        step="0.01"
                      />
                    </b-col>
                    <b-col
                      cols="6"
                      md="3"
                      class="mb-1"
                    >
                      <label class="font-small-3 text-muted">Min kalan ödül/risk</label>
                      <b-form-input
                        v-model.number="form.config.signalEntry.minRemainingRewardRisk"
                        type="number"
                        min="0"
                        step="0.01"
                      />
                    </b-col>
                    <b-col
                      cols="6"
                      md="3"
                      class="mb-1"
                    >
                      <label class="font-small-3 text-muted">Geç sinyal başlangıcı %</label>
                      <b-form-input
                        v-model.number="form.config.signalEntry.lateSignalPenaltyStartPct"
                        type="number"
                        min="0"
                        max="100"
                        step="1"
                      />
                    </b-col>
                    <b-col
                      cols="12"
                      md="3"
                      class="mb-1 d-flex align-items-end"
                    >
                      <b-form-checkbox
                        v-model="form.config.signalEntry.familyWeightEnabled"
                        switch
                      >
                        Aile performansı
                      </b-form-checkbox>
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
              <b-col
                cols="12"
                class="mb-1"
              >
                <b-form-checkbox
                  v-model="form.config.inheritEdgeTpSl"
                  switch
                >
                  <strong>TP/SL değerlerini edge'den miras al</strong>
                </b-form-checkbox>
                <small class="text-muted d-block">
                  Açıkken her bot bağlı olduğu edge'in TP/SL değerini kullanır. Kapatıldığında aşağıdaki sabit değerler override edilir.
                </small>
              </b-col>
              <b-col
                cols="12"
                class="mb-1"
              >
                <b-form-checkbox
                  v-model="form.config.exitOnIndicatorSignal"
                  switch
                >
                  <strong>Exit sinyaliyle pozisyondan çık</strong>
                </b-form-checkbox>
              </b-col>
              <b-col
                cols="6"
                md="3"
                class="mb-1"
              >
                <label class="font-small-3 text-muted">TP override %</label>
                <b-form-input
                  v-model.number="form.tpPerc"
                  type="number"
                  min="0.01"
                  step="0.05"
                  :disabled="form.config.inheritEdgeTpSl"
                />
              </b-col>
              <b-col
                cols="6"
                md="3"
                class="mb-1"
              >
                <label class="font-small-3 text-muted">SL override %</label>
                <b-form-input
                  v-model.number="form.slPerc"
                  type="number"
                  min="0.01"
                  step="0.05"
                  :disabled="form.config.inheritEdgeTpSl"
                />
              </b-col>
              <b-col
                cols="6"
                md="3"
                class="mb-1"
              >
                <label class="font-small-3 text-muted">Hedef Kar %</label>
                <b-form-input
                  v-model.number="form.profitTarget"
                  type="number"
                  min="0.1"
                  step="0.1"
                />
              </b-col>
              <b-col
                cols="6"
                md="3"
                class="mb-1"
              >
                <label class="font-small-3 text-muted">Aktif</label>
                <b-form-checkbox
                  v-model="form.isActive"
                  switch
                  class="mt-50"
                >
                  Kullanılabilir
                </b-form-checkbox>
              </b-col>
            </b-row>

            <hr>

            <div class="d-flex align-items-center mb-1">
              <h6 class="mb-0">
                Profil Dağılımı
              </h6>
              <b-button
                size="sm"
                variant="outline-primary"
                class="ml-auto"
                @click="addProfile"
              >
                <feather-icon icon="PlusIcon" /> Profil
              </b-button>
            </div>
            <b-table
              :items="form.config.profiles"
              :fields="profileFields"
              small
              responsive
            >
              <template #cell(name)="data">
                <b-form-input
                  v-model="data.item.name"
                  size="sm"
                />
              </template>
              <template #cell(budget)="data">
                <b-form-input
                  v-model.number="data.item.budget"
                  type="number"
                  size="sm"
                  min="1"
                  step="50"
                />
              </template>
              <template #cell(botCount)="data">
                <b-form-input
                  v-model.number="data.item.botCount"
                  type="number"
                  size="sm"
                  min="1"
                  step="1"
                />
              </template>
              <template #cell(capitalPerBot)="data">
                <b-form-input
                  v-model.number="data.item.capitalPerBot"
                  type="number"
                  size="sm"
                  min="1"
                  step="10"
                />
              </template>
              <template #cell(risk)="data">
                <b-form-input
                  v-model.number="data.item.riskUsdtPerTrade"
                  type="number"
                  size="sm"
                  min="1"
                  step="1"
                />
              </template>
              <template #cell(maxCapital)="data">
                <b-form-input
                  v-model.number="data.item.maxCapitalUsagePercent"
                  type="number"
                  size="sm"
                  min="1"
                  max="100"
                  step="5"
                />
              </template>
              <template #cell(guard)="data">
                <div class="d-flex">
                  <b-form-input
                    v-model.number="data.item.dailyGuard.maxDailyLossUsdt"
                    type="number"
                    size="sm"
                    min="1"
                    step="10"
                    class="mr-50"
                    title="Günlük max zarar"
                  />
                  <b-form-input
                    v-model.number="data.item.dailyGuard.cooldownMinutes"
                    type="number"
                    size="sm"
                    min="0"
                    step="5"
                    title="Cooldown dk"
                  />
                  <b-form-input
                    v-model.number="data.item.dailyProfitGuard.maxDailyProfitUsdt"
                    type="number"
                    size="sm"
                    min="1"
                    step="10"
                    class="ml-50"
                    title="Günlük max kar"
                  />
                </div>
                <b-form-checkbox
                  v-model="data.item.dailyProfitGuard.enabled"
                  size="sm"
                  class="mt-50"
                >
                  Günlük TP
                </b-form-checkbox>
              </template>
              <template #cell(actions)="data">
                <b-button
                  size="sm"
                  variant="outline-danger"
                  :disabled="form.config.profiles.length <= 1"
                  @click="removeProfile(data.index)"
                >
                  <feather-icon icon="Trash2Icon" />
                </b-button>
              </template>
            </b-table>

            <b-alert
              show
              variant="light-primary"
              class="py-1"
            >
              <small>
                Profil toplamı: <strong>{{ formatNum(profileBudgetTotal, 0) }} USDT</strong> ·
                Bot: <strong>{{ profileBotTotal }}</strong> ·
                Tahmini tek SL risk toplamı: <strong>{{ formatNum(profileRiskTotal, 2) }} USDT</strong>
              </small>
            </b-alert>

            <hr>

            <div class="exit-governor-panel mb-2">
              <div class="d-flex flex-wrap align-items-center mb-1">
                <div>
                  <h6 class="mb-0">
                    Exit Modu
                  </h6>
                  <small class="text-muted">Karı koru, dengele veya runner büyüt. Alt koruma ayarları bu baseline'dan çalışır.</small>
                </div>
                <b-badge
                  variant="light-primary"
                  class="ml-auto"
                >
                  {{ exitGovernorModeLabel(exitGovernorMode) }}
                </b-badge>
              </div>
              <div class="d-flex flex-wrap mb-1">
                <b-button
                  v-for="option in exitGovernorModeOptions"
                  :key="option.value"
                  size="sm"
                  class="mr-50 mb-50"
                  :variant="exitGovernorMode === option.value ? 'primary' : 'outline-primary'"
                  @click="applyExitGovernorMode(option.value)"
                >
                  {{ option.text }}
                </b-button>
              </div>
              <div class="font-small-3 text-muted">
                <div
                  v-for="line in exitGovernorModeSummary"
                  :key="line"
                  class="mb-50"
                >
                  {{ line }}
                </div>
              </div>
              <b-alert
                v-if="strategySafetyGovernorCoordinationSummaryLines.length"
                show
                variant="light-info"
                class="mt-1 mb-0 py-50"
              >
                <div
                  v-for="line in strategySafetyGovernorCoordinationSummaryLines"
                  :key="line"
                  class="font-small-3"
                >
                  {{ line }}
                </div>
              </b-alert>
              <b-badge
                variant="light-primary"
                class="mt-50 mr-50"
              >
                {{ strategySafetyGovernorCoordinationDecisionValue.kindLabel }} · {{ strategySafetyGovernorCoordinationDecisionValue.label }} · {{ strategySafetyGovernorCoordinationDecisionValue.text }}
              </b-badge>
              <div class="text-muted font-small-3 mt-25">
                {{ strategySafetyGovernorCoordinationStateValue.decisionSummary }}
              </div>
              <div class="text-muted font-small-3 mt-25">
                {{ strategySafetyGovernorCoordinationDecisionValue.detail }}
              </div>
              <div
                v-for="line in strategySafetyGovernorCoordinationStateValue.axisReasons"
                :key="`axis-${line.code}`"
                class="text-muted font-small-3 mt-25"
              >
                {{ line.label }} · {{ line.text }}
              </div>
              <div
                v-for="line in strategySafetyGovernorCoordinationStateValue.conflictReasons"
                :key="line.code"
                class="text-muted font-small-3 mt-25"
              >
                {{ line.label }} · {{ line.text }}
              </div>
              <div class="d-flex flex-wrap align-items-center mt-1">
                <b-badge
                  :variant="exitGovernorDrifted ? 'light-warning' : 'light-success'"
                  class="mr-50"
                >
                  {{ exitGovernorDrifted ? 'Mode’dan sapma var' : 'Mode baseline uyumlu' }}
                </b-badge>
                <b-button
                  v-if="exitGovernorDrifted"
                  size="sm"
                  variant="outline-warning"
                  @click="reapplyExitGovernorMode"
                >
                  <feather-icon icon="RotateCcwIcon" /> Mode’u yeniden uygula
                </b-button>
              </div>
            </div>

            <div class="d-flex align-items-center mb-1">
              <h6 class="mb-0">
                Canlı Strateji Okuması
              </h6>
              <b-badge
                :variant="strategyInsight.badgeVariant"
                class="ml-auto"
              >
                {{ strategyInsight.modeLabel }}
              </b-badge>
            </div>
            <b-row class="strategy-insight mb-2">
              <b-col
                cols="12"
                xl="5"
                class="mb-1 mb-xl-0"
              >
                <div class="insight-panel h-100">
                  <div class="insight-title">
                    <feather-icon
                      icon="ActivityIcon"
                      size="16"
                      class="mr-50"
                    />
                    Davranış Özeti
                  </div>
                  <ul class="insight-list mb-0">
                    <li
                      v-for="(line, idx) in strategyInsight.summary"
                      :key="`summary-${idx}`"
                    >
                      {{ line }}
                    </li>
                  </ul>
                </div>
              </b-col>
              <b-col
                cols="12"
                md="6"
                xl="3"
                class="mb-1 mb-xl-0"
              >
                <div class="insight-panel h-100">
                  <div class="insight-title">
                    <feather-icon
                      icon="ShieldIcon"
                      size="16"
                      class="mr-50"
                    />
                    Risk / Guard
                  </div>
                  <div
                    v-for="metric in strategyInsight.metrics"
                    :key="metric.label"
                    class="metric-row"
                  >
                    <span>{{ metric.label }}</span>
                    <strong>{{ metric.value }}</strong>
                  </div>
                </div>
              </b-col>
              <b-col
                cols="12"
                md="6"
                xl="4"
              >
                <div class="insight-panel h-100">
                  <div class="insight-title">
                    <feather-icon
                      icon="GitBranchIcon"
                      size="16"
                      class="mr-50"
                    />
                    MFE Zaman Çizgisi
                  </div>
                  <div class="timeline">
                    <div
                      v-for="event in strategyInsight.timeline"
                      :key="event.key"
                      class="timeline-item"
                    >
                      <span
                        class="timeline-dot"
                        :class="event.variant"
                      />
                      <span class="timeline-level">{{ event.level }}</span>
                      <span class="timeline-label">{{ event.label }}</span>
                      <span
                        v-if="event.usdt"
                        class="timeline-usdt"
                      >{{ event.usdt }}</span>
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-alert
              v-for="alert in strategyInsight.healthAlerts"
              :key="alert.message"
              show
              :variant="alert.variant"
              class="py-1 mb-50"
            >
              <small><feather-icon
                :icon="alert.icon"
                size="14"
                class="mr-50"
              />{{ alert.message }}</small>
            </b-alert>
            <b-alert
              v-for="warning in strategyInsight.warnings"
              :key="warning"
              show
              variant="light-warning"
              class="py-1 mb-50"
            >
              <small><feather-icon
                icon="AlertTriangleIcon"
                size="14"
                class="mr-50"
              />{{ warning }}</small>
            </b-alert>

            <div class="d-flex align-items-center mt-2 mb-1">
              <div>
                <h6 class="mb-0">
                  K/Z Sağlık Paneli
                </h6>
                <small class="text-muted">Son kapanan işlemlerden gerçek avg win/loss ve SL taşıma yeterliliği</small>
              </div>
              <b-button
                size="sm"
                variant="outline-primary"
                class="ml-auto"
                :disabled="pnlHealthLoading"
                @click="fetchPnlHealth"
              >
                <b-spinner
                  v-if="pnlHealthLoading"
                  small
                />
                <feather-icon
                  v-else
                  icon="RefreshCwIcon"
                />
                Yenile
              </b-button>
            </div>
            <div class="pnl-tune-control mb-1">
              <b-form-checkbox
                v-model="form.config.pnlHealthAutoTune.enabled"
                switch
                @change="onPnlAutoTuneToggle"
              >
                <strong>K/Z sağlık paneline göre otomatik ayarla</strong>
              </b-form-checkbox>
              <div class="d-flex flex-wrap align-items-center mt-50">
                <small class="text-muted mr-1">
                  Default kapalıdır; açıkken panel öneri üretir, değerler sadece onayla forma işlenir.
                </small>
                <b-button
                  size="sm"
                  variant="outline-info"
                  class="mr-50"
                  :disabled="!form.config.pnlHealthAutoTune.enabled || pnlHealthLoading"
                  @click="generatePnlAutoTuneSuggestion"
                >
                  <feather-icon icon="SlidersIcon" /> Öneri oluştur
                </b-button>
                <b-button
                  size="sm"
                  variant="success"
                  :disabled="!form.config.pnlHealthAutoTune.enabled || !pnlAutoTuneSuggestion"
                  @click="applyPnlAutoTuneSuggestion"
                >
                  <feather-icon icon="CheckIcon" /> Öneriyi uygula
                </b-button>
              </div>
            </div>
            <div class="pnl-health-panel mb-2">
              <div
                v-if="pnlHealthLoading"
                class="text-center py-2"
              >
                <b-spinner small /> Hesaplanıyor...
              </div>
              <template v-else-if="pnlHealth">
                <b-row>
                  <b-col
                    v-for="metric in pnlHealthMetricCards"
                    :key="metric.label"
                    cols="6"
                    md="3"
                    class="mb-1"
                  >
                    <div class="pnl-metric">
                      <span>{{ metric.label }}</span>
                      <strong :class="metric.className">{{ metric.value }}</strong>
                    </div>
                  </b-col>
                </b-row>
                <b-alert
                  v-for="alert in pnlHealth.alerts || []"
                  :key="alert.message"
                  show
                  :variant="pnlHealthAlertVariant(alert.severity)"
                  class="py-1 mb-50"
                >
                  <small><feather-icon
                    :icon="pnlHealthAlertIcon(alert.severity)"
                    size="14"
                    class="mr-50"
                  />{{ alert.message }}</small>
                </b-alert>
                <div class="pnl-health-grid mt-1">
                  <div>
                    <div class="insight-title mb-50">
                      <feather-icon
                        icon="PieChartIcon"
                        size="16"
                        class="mr-50"
                      />
                      Kapanış Sebepleri
                    </div>
                    <div v-if="pnlHealth.closeReasons && pnlHealth.closeReasons.length">
                      <div
                        v-for="reason in pnlHealth.closeReasons.slice(0, 6)"
                        :key="reason.reason"
                        class="metric-row"
                      >
                        <span>{{ reason.reason }} · {{ reason.count }}</span>
                        <strong :class="Number(reason.pnl) >= 0 ? 'text-success' : 'text-danger'">{{ formatSignedMoney(reason.pnl) }}</strong>
                      </div>
                    </div>
                    <small
                      v-else
                      class="text-muted"
                    >Kapanış sebebi yok.</small>
                  </div>
                  <div>
                    <div class="insight-title mb-50">
                      <feather-icon
                        icon="ClockIcon"
                        size="16"
                        class="mr-50"
                      />
                      Son İşlemler
                    </div>
                    <div v-if="pnlHealth.recent && pnlHealth.recent.length">
                      <div
                        v-for="trade in pnlHealth.recent.slice(0, 6)"
                        :key="trade.id"
                        class="metric-row"
                      >
                        <span>{{ trade.symbol }} · {{ trade.closeReason }}</span>
                        <strong :class="Number(trade.pnl) >= 0 ? 'text-success' : 'text-danger'">{{ formatSignedMoney(trade.pnl) }}</strong>
                      </div>
                    </div>
                    <small
                      v-else
                      class="text-muted"
                    >Bu kapsamda kapanmış işlem yok.</small>
                  </div>
                </div>
                <small class="text-muted d-block mt-1">
                  Kapsam: {{ pnlHealth.scope.mode }} · {{ pnlHealth.scope.market }} · {{ pnlHealth.scope.edgeKind }} · son {{ pnlHealth.scope.lookbackDays }} gün / {{ pnlHealth.scope.sampleLimit }} işlem
                </small>
              </template>
              <b-alert
                v-else
                show
                variant="light-info"
                class="mb-0"
              >
                <small>K/Z sağlık verisi için Yenile butonuna bas.</small>
              </b-alert>
            </div>
            <b-alert
              v-if="pnlAutoTuneSuggestion"
              show
              variant="light-info"
              class="py-1 mb-2"
            >
              <div class="font-weight-bold mb-50">
                K/Z otomatik ayar önerisi
              </div>
              <div class="mb-50">
                <b-badge variant="light-primary">
                  {{ exitGovernorModeLabel(pnlAutoTuneSuggestion.recommendedMode) }}
                </b-badge>
              </div>
              <div class="font-small-3 text-muted mb-50">
                Setup okuması: {{ pnlAutoTuneSuggestion.modeReason }}
              </div>
              <div
                v-for="line in pnlAutoTuneSuggestion.summary"
                :key="line"
                class="font-small-3"
              >
                {{ line }}
              </div>
              <div class="mt-50">
                <b-badge
                  v-for="change in pnlAutoTuneSuggestion.changes"
                  :key="change"
                  variant="light-primary"
                  class="mr-50 mb-50"
                >
                  {{ change }}
                </b-badge>
              </div>
            </b-alert>

            <hr>

            <h6>K/Z ve SL Taşıma</h6>
            <b-row>
              <b-col
                cols="12"
                md="6"
                class="mb-1"
              >
                <b-form-checkbox
                  v-model="form.config.positionManagement.breakEven.enabled"
                  switch
                >
                  <strong>Break-even</strong>
                </b-form-checkbox>
                <b-row class="mt-1">
                  <b-col cols="6">
                    <label class="font-small-3 text-muted">Trigger %</label><b-form-input
                      v-model.number="form.config.positionManagement.breakEven.triggerProfit"
                      type="number"
                      step="0.01"
                    />
                  </b-col>
                  <b-col cols="6">
                    <label class="font-small-3 text-muted">Buffer %</label><b-form-input
                      v-model.number="form.config.positionManagement.breakEven.bufferProfit"
                      type="number"
                      step="0.01"
                    />
                  </b-col>
                  <b-col
                    cols="6"
                    class="mt-50"
                  >
                    <label class="font-small-3 text-muted">Buffer modu</label><b-form-select
                      v-model="form.config.positionManagement.breakEven.bufferMode"
                      :options="breakEvenBufferModeOptions"
                    />
                  </b-col>
                  <b-col
                    cols="6"
                    class="mt-50"
                  >
                    <label class="font-small-3 text-muted">Kayma tamponu %</label><b-form-input
                      v-model.number="form.config.positionManagement.breakEven.slippageBufferPct"
                      type="number"
                      step="0.01"
                      min="0"
                      :disabled="form.config.positionManagement.breakEven.bufferMode === 'RAW'"
                    />
                  </b-col>
                  <b-col
                    cols="12"
                    class="mt-50"
                  >
                    <b-form-checkbox v-model="form.config.positionManagement.breakEven.includeFees">
                      Komisyonu dahil et
                    </b-form-checkbox>
                  </b-col>
                </b-row>
              </b-col>
              <b-col
                cols="12"
                md="6"
                class="mb-1"
              >
                <b-form-checkbox
                  v-model="form.config.positionManagement.partialTp.enabled"
                  switch
                >
                  <strong>Partial TP</strong>
                </b-form-checkbox>
                <b-row class="mt-1">
                  <b-col cols="6">
                    <label class="font-small-3 text-muted">Kâr %</label><b-form-input
                      v-model.number="form.config.positionManagement.partialTp.atProfit"
                      type="number"
                      step="0.01"
                    />
                  </b-col>
                  <b-col cols="6">
                    <label class="font-small-3 text-muted">Kapat %</label><b-form-input
                      v-model.number="form.config.positionManagement.partialTp.takePercent"
                      type="number"
                      step="5"
                    />
                  </b-col>
                </b-row>
              </b-col>
              <b-col
                cols="12"
                md="6"
                class="mb-1"
              >
                <b-form-checkbox
                  v-model="form.config.positionManagement.trailTp.enabled"
                  switch
                >
                  <strong>Trail TP / Profit Lock</strong>
                </b-form-checkbox>
                <b-row class="mt-1">
                  <b-col cols="6">
                    <label class="font-small-3 text-muted">Trigger %</label><b-form-input
                      v-model.number="form.config.positionManagement.trailTp.triggerProfit"
                      type="number"
                      step="0.01"
                    />
                  </b-col>
                  <b-col cols="6">
                    <label class="font-small-3 text-muted">Aralık %</label><b-form-input
                      v-model.number="form.config.positionManagement.trailTp.trailPercent"
                      type="number"
                      step="0.01"
                    />
                  </b-col>
                </b-row>
              </b-col>
              <b-col
                cols="12"
                md="6"
                class="mb-1"
              >
                <b-form-checkbox
                  v-model="form.config.positionManagement.riskSizing.enabled"
                  switch
                >
                  <strong>Risk bazlı qty</strong>
                </b-form-checkbox>
                <div class="text-muted font-small-3 mt-50">
                  Kapalıysa bot başı sermaye doğrudan kullanılır.
                </div>
              </b-col>
              <b-col
                cols="12"
                md="6"
                class="mb-1"
              >
                <b-form-checkbox
                  v-model="form.config.positionManagement.globalExposure.enabled"
                  switch
                >
                  <strong>Aynı coin kilidi</strong>
                </b-form-checkbox>
                <b-form-checkbox
                  v-model="form.config.positionManagement.globalExposure.blockOppositeSide"
                  class="mt-1"
                >
                  Ters yönü de engelle
                </b-form-checkbox>
              </b-col>
            </b-row>

            <div class="d-flex align-items-center mb-1">
              <h6 class="mb-0">
                Step Stop
              </h6>
              <b-form-checkbox
                v-model="form.config.stepStop.enabled"
                switch
                class="ml-auto"
              >
                Aktif
              </b-form-checkbox>
            </div>
            <b-row>
              <b-col
                v-for="(step, idx) in form.config.stepStop.steps"
                :key="idx"
                cols="12"
                md="6"
                class="mb-1"
              >
                <b-input-group :prepend="`Kademe ${idx + 1}`">
                  <b-form-input
                    v-model.number="step.atProfit"
                    type="number"
                    step="0.01"
                  />
                  <b-form-input
                    v-model.number="step.moveStopTo"
                    type="number"
                    step="0.01"
                  />
                </b-input-group>
              </b-col>
            </b-row>

            <div class="text-right mt-2">
              <b-button
                variant="outline-danger"
                class="mr-1"
                :disabled="!form.id || form.isDefault"
                @click="removeStrategy"
              >
                <feather-icon icon="Trash2Icon" /> Sil
              </b-button>
              <b-button
                variant="outline-success"
                class="mr-1"
                :disabled="!form.id"
                @click="openApply(form)"
              >
                <feather-icon icon="ZapIcon" /> Uygula
              </b-button>
              <b-button
                variant="primary"
                :disabled="!canSave"
                @click="saveStrategy"
              >
                <feather-icon icon="CheckIcon" /> Kaydet
              </b-button>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-modal
      v-model="applyModal.show"
      title="Stratejiyi Uygula"
      size="md"
      hide-footer
    >
      <b-alert
        show
        variant="warning"
        class="py-1"
      >
        <small>Bu işlem profiller kadar hedef oluşturur ve aktif edge'lerden botları provision eder.</small>
      </b-alert>
      <b-row>
        <b-col
          cols="6"
          class="mb-1"
        >
          <label class="font-small-3 text-muted">Mod</label><b-form-select
            v-model="applyForm.mode"
            :options="modeOptions"
          />
        </b-col>
        <b-col
          cols="6"
          class="mb-1"
        >
          <label class="font-small-3 text-muted">Market</label><b-form-select
            v-model="applyForm.market"
            :options="marketOptions"
          />
        </b-col>
        <b-col
          cols="6"
          class="mb-1"
        >
          <label class="font-small-3 text-muted">Edge Türü</label><b-form-select
            v-model="applyForm.edgeKind"
            :options="edgeKindOptions"
          />
        </b-col>
        <b-col
          cols="6"
          class="mb-1"
        >
          <label class="font-small-3 text-muted">API Anahtarı</label><b-form-select
            v-model="applyForm.apiKeyId"
            :options="apiKeyOptions"
          />
        </b-col>
        <b-col
          cols="12"
          class="mb-1"
        >
          <label class="font-small-3 text-muted">İsim Öneki</label><b-form-input v-model="applyForm.namePrefix" />
        </b-col>
        <b-col
          cols="12"
          class="mb-1"
        >
          <b-form-checkbox
            v-model="applyForm.autoStart"
            switch
          >
            Oluşturduktan sonra başlat
          </b-form-checkbox>
        </b-col>
      </b-row>
      <div
        v-if="applyResult"
        class="mb-1"
      >
        <b-alert
          show
          variant="success"
          class="py-1"
        >
          <strong>{{ applyResult.createdTargets.length }}</strong> hedef oluşturuldu.
        </b-alert>
      </div>
      <div class="text-right">
        <b-button
          variant="secondary"
          class="mr-1"
          @click="applyModal.show = false"
        >
          İptal
        </b-button>
        <b-button
          variant="success"
          :disabled="applying || !canApply"
          @click="applyStrategy"
        >
          <b-spinner
            v-if="applying"
            small
          />
          <feather-icon
            v-else
            icon="ZapIcon"
          /> {{ applying ? 'Uygulanıyor...' : 'Uygula ve Oluştur' }}
        </b-button>
      </div>
    </b-modal>

    <b-modal
      v-model="profileCheckModal.show"
      title="Profil Kontrolü"
      size="lg"
      hide-footer
    >
      <template v-if="profileCheckModal.result">
        <b-alert
          show
          :variant="profileCheckDecisionVariant"
          class="py-1"
        >
          <strong>{{ profileCheckModal.result.title }}</strong>
        </b-alert>

        <ul class="mb-1">
          <li
            v-for="(line, idx) in profileCheckModal.result.summary"
            :key="`pc-summary-${idx}`"
          >
            {{ line }}
          </li>
        </ul>

        <b-alert
          v-for="alert in profileCheckModal.result.alerts"
          :key="alert.message"
          show
          :variant="profileAlertVariant(alert.severity)"
          class="py-1 mb-50"
        >
          <small><feather-icon
            :icon="profileAlertIcon(alert.severity)"
            size="14"
            class="mr-50"
          />{{ alert.message }}</small>
        </b-alert>

        <b-row class="mt-1">
          <b-col
            cols="12"
            md="6"
            class="mb-1"
          >
            <div class="insight-panel h-100">
              <div class="insight-title">
                Top aktif edge
              </div>
              <div
                v-if="!(profileCheckModal.result.stats.topEdges || []).length"
                class="text-muted font-small-3"
              >
                Aktif edge yok.
              </div>
              <div
                v-for="edge in profileCheckModal.result.stats.topEdges"
                :key="edge.id"
                class="font-small-3 mb-50"
              >
                <strong>{{ edge.symbol }}</strong> {{ edge.timeframe }}
                <span class="text-muted">· score {{ formatNum(edge.scoreFinal, 2) }} · WR {{ formatNum(edge.winRate, 0) }}% · seri {{ edge.recentPattern }}</span>
              </div>
            </div>
          </b-col>
          <b-col
            cols="12"
            md="6"
            class="mb-1"
          >
            <div class="insight-panel h-100">
              <div class="insight-title">
                Açık pozisyon örnekleri
              </div>
              <div
                v-if="!(profileCheckModal.result.stats.openPositionSamples || []).length"
                class="text-muted font-small-3"
              >
                Aktif edge sembollerinde açık pozisyon yok.
              </div>
              <div
                v-for="position in profileCheckModal.result.stats.openPositionSamples"
                :key="position.id"
                class="font-small-3 mb-50"
              >
                <strong>{{ position.symbol }}</strong> {{ position.side }}
                <span :class="Number(position.pnl) >= 0 ? 'text-success' : 'text-danger'">
                  · {{ Number(position.pnl) >= 0 ? '+' : '' }}{{ formatNum(position.pnl, 2) }}
                </span>
                <span class="text-muted"> · {{ position.botName }}</span>
              </div>
            </div>
          </b-col>
        </b-row>

        <b-alert
          show
          variant="light-info"
          class="py-1"
        >
          <small>
            Öneriyi uygularsan formdaki pool/filtre/otomatik hesap ayarları güncellenir. Kaydetmeden kalıcı olmaz.
          </small>
        </b-alert>

        <div class="text-right">
          <b-button
            variant="secondary"
            class="mr-1"
            @click="profileCheckModal.show = false"
          >
            Güvenli modda kal
          </b-button>
          <b-button
            variant="primary"
            @click="applyProfileCheckSuggestion"
          >
            <feather-icon icon="CheckIcon" /> Öneriyi uygula
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {
  BAlert, BBadge, BButton, BCard, BCardBody, BCol, BFormCheckbox,
  BFormInput, BFormSelect, BFormTextarea, BInputGroup, BModal, BRow,
  BSpinner, BTable,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axiosIns from '@/libs/axios'
import { applyEntryQualityPreset, extractEntryPresetRows } from '@/utils/entryQualityPresets'
import {
  strategySafetyGovernorDecisionReason as buildStrategySafetyGovernorCoordinationDecision,
  strategySafetyGovernorCoordinationState as buildStrategySafetyGovernorCoordinationState,
  strategySafetyGovernorCoordinationSummary as buildStrategySafetyGovernorCoordinationSummary,
} from '@/utils/strategySafetyGovernorCoordination'
import {
  EXIT_GOVERNOR_MODE_OPTIONS,
  applyExitGovernorModePreset,
  exitGovernorModeLabel,
  exitGovernorSummary,
  isExitGovernorDrifted,
  recommendExitGovernorModeFromPnlHealth,
  resolveExitGovernorMode,
} from '@/utils/exitGovernorModes'

export default {
  name: 'ProfitStrategiesIndex',
  components: {
    BAlert,
    BBadge,
    BButton,
    BCard,
    BCardBody,
    BCol,
    BFormCheckbox,
    BFormInput,
    BFormSelect,
    BFormTextarea,
    BInputGroup,
    BModal,
    BRow,
    BSpinner,
    BTable,
  },
  data() {
    return {
      loading: false,
      applying: false,
      profileChecking: false,
      pnlHealthLoading: false,
      searchTimer: null,
      filter: { search: '' },
      form: null,
      pnlHealth: null,
      pnlAutoTuneSuggestion: null,
      entryPresetState: {
        loading: false,
        rows: [],
        autoApplyEnabled: false,
        autoAppliedPresetKeys: [],
      },
      applyModal: { show: false, strategy: null },
      profileCheckModal: { show: false, result: null },
      applyForm: {
        mode: 'TESTNET', market: 'FUTURES', edgeKind: 'QUICK_GAIN', apiKeyId: null, autoStart: false, namePrefix: '',
      },
      modeOptions: [{ value: 'TESTNET', text: 'Testnet' }, { value: 'LIVE', text: 'Live' }],
      marketOptions: [{ value: 'FUTURES', text: 'Futures' }, { value: 'SPOT', text: 'Spot' }],
      edgeKindOptions: [{ value: 'QUICK_GAIN', text: 'Quick Gain' }, { value: 'NORMAL', text: 'Normal' }],
      exitGovernorModeOptions: EXIT_GOVERNOR_MODE_OPTIONS,
      breakEvenBufferModeOptions: [
        { value: 'NET', text: 'Net hedef' },
        { value: 'RAW', text: 'Ham fiyat' },
      ],
      riskModeOptions: [
        { value: 'SAFE', text: 'Güvenli' },
        { value: 'BALANCED', text: 'Dengeli' },
        { value: 'AGGRESSIVE', text: 'Agresif' },
      ],
      consensusInsufficientOptions: [
        { value: 'WAIT', text: 'Giriş için sinyal bekle' },
        { value: 'ALLOW', text: 'Girişe izin ver' },
      ],
      strategyFields: [
        { key: 'name', label: 'Strateji' },
        { key: 'actions', label: '', thClass: 'text-right' },
      ],
      profileFields: [
        { key: 'name', label: 'Profil' },
        { key: 'budget', label: 'Bütçe' },
        { key: 'botCount', label: 'Bot' },
        { key: 'capitalPerBot', label: 'Bot başı' },
        { key: 'risk', label: 'Risk' },
        { key: 'maxCapital', label: 'Max %' },
        { key: 'guard', label: 'Guard / Günlük TP' },
        { key: 'actions', label: '' },
      ],
    }
  },
  computed: {
    strategies() { return this.$store.getters['profitStrategies/dataList'] || [] },
    saveStatus() { return this.$store.getters['profitStrategies/dataSaveStatus'] },
    applyResult() { return this.$store.getters['profitStrategies/applyResult'] },
    apiKeyOptions() {
      const list = this.$store.getters['apiKeys/dataList'] || []
      return [
        { value: null, text: '— testnet / seç —' },
        ...list.filter(k => k.isActive).map(k => ({
          value: k.id,
          text: `${k.provider ? k.provider.name : '?'} · ${k.label || '(etiketsiz)'}`,
        })),
      ]
    },
    autoCalculationSummary() {
      const cfg = this.form?.config?.autoCalculation || {}
      if (!cfg.enabled) return 'Kapalı; değerler tamamen manuel yönetilir.'
      const mode = this.riskModeOptions.find(option => option.value === cfg.riskMode)?.text || 'Dengeli'
      return `${mode} preset aktif; bütçe, bot ve kaldıraç değişince profil/risk önerileri güncellenir.`
    },
    profileCheckDecisionVariant() {
      const decision = this.profileCheckModal.result?.decision
      if (decision === 'POOL_CAN_BE_USED') return 'success'
      if (decision === 'POOL_NEEDS_APPROVAL') return 'warning'
      return 'info'
    },
    pnlHealthMetricCards() {
      const m = this.pnlHealth?.metrics || {}
      const coverage = m.coverageRatio === null || m.coverageRatio === undefined
        ? '—'
        : `${this.formatNum(Number(m.coverageRatio) * 100, 0)}%`
      return [
        { label: 'İşlem / WR', value: `${Number(m.trades || 0)} · %${this.formatNum(m.winRate, 1)}` },
        { label: 'Toplam PnL', value: this.formatSignedMoney(m.totalPnl), className: Number(m.totalPnl || 0) >= 0 ? 'text-success' : 'text-danger' },
        { label: 'Avg Win', value: this.formatMoney(m.avgWin) },
        { label: 'Avg Loss', value: this.formatMoney(m.avgLoss), className: Number(m.avgLoss || 0) > 0 ? 'text-danger' : '' },
        { label: 'Gerekli Avg Win', value: this.formatMoney(m.requiredAvgWin), className: Number(m.requiredAvgWin || 0) > Number(m.avgWin || 0) ? 'text-danger' : 'text-success' },
        { label: 'Karşılama', value: coverage, className: Number(m.coverageRatio || 0) >= 1 ? 'text-success' : 'text-danger' },
        { label: 'Profit Factor', value: m.profitFactor === null || m.profitFactor === undefined ? '∞' : this.formatNum(m.profitFactor, 2), className: Number(m.profitFactor || 0) >= 1.2 ? 'text-success' : 'text-warning' },
        { label: 'Expectancy', value: this.formatSignedMoney(m.expectancy), className: Number(m.expectancy || 0) >= 0 ? 'text-success' : 'text-danger' },
      ]
    },
    exitGovernorMode() {
      return resolveExitGovernorMode(this.form?.config?.exitGovernor?.mode)
    },
    exitGovernorModeSummary() {
      return exitGovernorSummary(this.exitGovernorMode)
    },
    strategySafetyGovernorCoordinationSummaryLines() {
      return buildStrategySafetyGovernorCoordinationSummary(this.form?.config?.positionGuardian || {})
    },
    strategySafetyGovernorCoordinationDecisionValue() {
      return this.form?.config?.positionGuardian
        ? buildStrategySafetyGovernorCoordinationDecision(this.form.config.positionGuardian)
        : { code: 'NONE', text: 'Guardrail kapalı.' }
    },
    strategySafetyGovernorCoordinationStateValue() {
      return buildStrategySafetyGovernorCoordinationState(this.form?.config?.positionGuardian || {})
    },
    exitGovernorDrifted() {
      return this.form?.config ? isExitGovernorDrifted(this.form.config) : false
    },
    profileBudgetTotal() {
      return (this.form?.config?.profiles || []).reduce((s, p) => s + (Number(p.budget) || 0), 0)
    },
    profileBotTotal() {
      return (this.form?.config?.profiles || []).reduce((s, p) => s + (Number(p.botCount) || 0), 0)
    },
    profileRiskTotal() {
      return (this.form?.config?.profiles || []).reduce((s, p) => s + ((Number(p.riskUsdtPerTrade) || 0) * (Number(p.botCount) || 0)), 0)
    },
    strategyInsight() {
      if (!this.form) {
        return {
          summary: [], metrics: [], timeline: [], warnings: [], healthAlerts: [], modeLabel: 'Hazır', badgeVariant: 'light-secondary',
        }
      }

      const profiles = this.form.config?.profiles || []
      const pm = this.form.config?.positionManagement || {}
      const breakEven = pm.breakEven || {}
      const partialTp = pm.partialTp || {}
      const trailTp = pm.trailTp || {}
      const stepStop = this.form.config?.stepStop || {}
      const steps = (stepStop.steps || [])
        .map((step, idx) => ({
          key: `step-${idx}`,
          atProfit: Number(step.atProfit) || 0,
          moveStopTo: Number(step.moveStopTo) || 0,
        }))
        .filter(step => step.atProfit > 0)
        .sort((a, b) => a.atProfit - b.atProfit)

      const summary = []
      if (breakEven.enabled) {
        const modeText = breakEven.bufferMode === 'RAW' ? 'ham fiyat' : 'net hedef'
        const slippageText = breakEven.bufferMode === 'RAW' ? '' : `, kayma tamponu +${this.formatNum(breakEven.slippageBufferPct || 0, 2)}%`
        summary.push(`+${this.formatNum(breakEven.triggerProfit, 2)}% MFE görülürse SL ${modeText} modunda ${Number(breakEven.bufferProfit) > 0 ? `+${this.formatNum(breakEven.bufferProfit, 2)}% buffer` : 'break-even seviyesine'} taşınır${breakEven.includeFees ? ', komisyon hesaba katılır' : ''}${slippageText}.`)
      } else {
        summary.push('Break-even kapalı; pozisyon ilk korumaya kadar gerçek SL riskini taşır.')
      }
      if (partialTp.enabled) {
        summary.push(`+${this.formatNum(partialTp.atProfit, 2)}% MFE görülürse pozisyonun %${this.formatNum(partialTp.takePercent, 0)} kısmı kapatılır${partialTp.moveRemainderToBreakEven ? ', kalan break-even bölgesine alınır' : ''}.`)
      }
      if (trailTp.enabled) {
        summary.push(`+${this.formatNum(trailTp.triggerProfit, 2)}% sonrası kalan pozisyon ${this.formatNum(trailTp.trailPercent, 2)}% trail aralığıyla korunur.`)
      }
      if (stepStop.enabled && steps.length) {
        const first = steps[0]
        const last = steps[steps.length - 1]
        summary.push(`Step stop +${this.formatNum(first.atProfit, 2)}% seviyesinde SL'i +${this.formatNum(first.moveStopTo, 2)}% bölgesine taşımaya başlar; son kademe +${this.formatNum(last.atProfit, 2)}% -> +${this.formatNum(last.moveStopTo, 2)}%.`)
      }
      if (pm.globalExposure?.enabled) {
        summary.push(`Aynı coin kilidi açık; açık/pending pozisyon varken aynı coinde yeni giriş sınırlandırılır${pm.globalExposure.blockOppositeSide ? ' ve ters yön de engellenir' : ''}.`)
      }
      summary.push(this.form.config?.targetSignalPoolEnabled
        ? 'Bot müsait olduğunda hedefin aktif edge havuzundaki taze sinyalleri alabilir; bot tek edge ile sınırlı kalmaz.'
        : 'Botlar sabit edge yöntemiyle çalışır; her bot atanmış edge sinyalini bekler.')
      if (this.form.config?.targetSignalPoolEnabled) {
        const pool = this.normalizePoolFilters(this.form.config.targetSignalPoolFilters)
        summary.push(`Pool filtresi: ilk ${pool.maxEdges} edge, min score ${this.formatNum(pool.minScoreFinal, 2)}, min WR %${this.formatNum(pool.minWinRate, 0)}, min EV ${this.formatNum(pool.minNetEv, 2)}, min trade ${pool.minTrades}, +0,50 MFE %${this.formatNum(pool.minMfe50Rate, 0)}.`)
      }

      const protectionTriggers = []
      if (breakEven.enabled && Number(breakEven.triggerProfit) > 0) protectionTriggers.push(Number(breakEven.triggerProfit))
      if (partialTp.enabled && Number(partialTp.atProfit) > 0) protectionTriggers.push(Number(partialTp.atProfit))
      if (trailTp.enabled && Number(trailTp.triggerProfit) > 0) protectionTriggers.push(Number(trailTp.triggerProfit))
      if (stepStop.enabled) steps.forEach(step => protectionTriggers.push(step.atProfit))
      const firstProtection = protectionTriggers.length ? Math.min(...protectionTriggers) : null

      const weightedMaxPosition = profiles.reduce((sum, profile) => {
        const botCount = Number(profile.botCount) || 0
        const capital = Number(profile.capitalPerBot) || 0
        const maxCapitalPct = Number(profile.maxCapitalUsagePercent) || 0
        return sum + (capital * botCount * (Number(this.form.leverage) || 1) * (maxCapitalPct / 100))
      }, 0)
      const singleBotNotional = this.profileBotTotal > 0 ? weightedMaxPosition / this.profileBotTotal : 0
      const timelineUsdt = pct => {
        const amount = singleBotNotional * ((Number(pct) || 0) / 100)
        if (!Number.isFinite(amount) || amount === 0) return null
        const sign = amount >= 0 ? '+' : '-'
        return `≈ ${sign}${this.formatNum(Math.abs(amount), 2)} USDT / tek bot için`
      }
      const dailyLossGuard = profiles.reduce((sum, profile) => {
        if (!profile.dailyGuard?.enabled) return sum
        return sum + (Number(profile.dailyGuard.maxDailyLossUsdt) || 0)
      }, 0)
      const dailyProfitGuard = profiles.reduce((sum, profile) => {
        if (!profile.dailyProfitGuard?.enabled) return sum
        return sum + (Number(profile.dailyProfitGuard.maxDailyProfitUsdt) || 0)
      }, 0)
      const avgRisk = this.profileBotTotal > 0 ? this.profileRiskTotal / this.profileBotTotal : 0
      const metrics = [
        { label: 'İlk koruma MFE', value: firstProtection === null ? 'Kapalı' : `+${this.formatNum(firstProtection, 2)}%` },
        { label: 'Tek tur risk', value: `${this.formatNum(this.profileRiskTotal, 2)} USDT` },
        { label: 'Bot başı ort. risk', value: `${this.formatNum(avgRisk, 2)} USDT` },
        { label: 'Tahmini max pozisyon', value: `${this.formatNum(weightedMaxPosition, 0)} USDT` },
        { label: 'Günlük zarar freni', value: dailyLossGuard > 0 ? `${this.formatNum(dailyLossGuard, 0)} USDT` : 'Kapalı' },
        { label: 'Günlük TP limiti', value: dailyProfitGuard > 0 ? `${this.formatNum(dailyProfitGuard, 0)} USDT` : 'Kapalı' },
      ]

      const timeline = [
        {
          key: 'entry', at: -999, level: 'Entry', label: 'Pozisyon açılır', variant: 'primary',
        },
        {
          key: 'sl', at: -Number(this.form.slPerc || 0), level: `-${this.formatNum(this.form.slPerc, 2)}%`, label: 'Edge SL', variant: 'danger', usdt: timelineUsdt(-Number(this.form.slPerc || 0)),
        },
      ]
      if (breakEven.enabled) {
        timeline.push({
          key: 'be', at: Number(breakEven.triggerProfit) || 0, level: `+${this.formatNum(breakEven.triggerProfit, 2)}%`, label: 'Break-even', variant: 'success', usdt: timelineUsdt(breakEven.triggerProfit),
        })
      }
      if (partialTp.enabled) {
        timeline.push({
          key: 'partial', at: Number(partialTp.atProfit) || 0, level: `+${this.formatNum(partialTp.atProfit, 2)}%`, label: `Partial TP %${this.formatNum(partialTp.takePercent, 0)}`, variant: 'success', usdt: timelineUsdt(partialTp.atProfit),
        })
      }
      if (trailTp.enabled) {
        timeline.push({
          key: 'trail', at: Number(trailTp.triggerProfit) || 0, level: `+${this.formatNum(trailTp.triggerProfit, 2)}%`, label: `Trail ${this.formatNum(trailTp.trailPercent, 2)}%`, variant: 'info', usdt: timelineUsdt(trailTp.triggerProfit),
        })
      }
      if (stepStop.enabled) {
        steps.forEach((step, idx) => {
          timeline.push({
            key: step.key, at: step.atProfit, level: `+${this.formatNum(step.atProfit, 2)}%`, label: `Step ${idx + 1}: SL +${this.formatNum(step.moveStopTo, 2)}%`, variant: 'warning', usdt: timelineUsdt(step.atProfit),
          })
        })
      }
      timeline.push({
        key: 'tp', at: Number(this.form.tpPerc || 0), level: `+${this.formatNum(this.form.tpPerc, 2)}%`, label: 'Edge TP', variant: 'success', usdt: timelineUsdt(this.form.tpPerc),
      })
      timeline.sort((a, b) => a.at - b.at)

      const warnings = []
      const healthAlerts = []
      if (Math.abs(this.profileBudgetTotal - (Number(this.form.totalBudget) || 0)) > 1) {
        warnings.push(`Profil bütçe toplamı strateji bütçesinden farklı: ${this.formatNum(this.profileBudgetTotal, 0)} / ${this.formatNum(this.form.totalBudget, 0)} USDT.`)
      }
      if (this.profileBotTotal !== (Number(this.form.totalBots) || 0)) {
        warnings.push(`Profil bot toplamı strateji bot sayısıyla eşleşmiyor: ${this.profileBotTotal} / ${Number(this.form.totalBots) || 0}.`)
      }
      if (firstProtection !== null && Number(this.form.tpPerc) > 0 && firstProtection >= Number(this.form.tpPerc)) {
        warnings.push('İlk koruma eşiği Edge TP seviyesine eşit veya daha yüksek; koruma çoğu işlemde devreye girmeyebilir.')
      }
      if (breakEven.enabled && partialTp.enabled && Number(breakEven.triggerProfit) > Number(partialTp.atProfit)) {
        warnings.push('Partial TP, break-even’dan önce çalışıyor; kalan pozisyon bir süre gerçek SL riski taşıyabilir.')
      }
      if (trailTp.enabled && partialTp.enabled && Number(trailTp.triggerProfit) < Number(partialTp.atProfit)) {
        warnings.push('Trail trigger partial TP seviyesinden önce; aynı bölgede iki kâr alma mantığı çakışabilir.')
      }
      steps.forEach((step, idx) => {
        if (step.moveStopTo >= step.atProfit) {
          warnings.push(`Step ${idx + 1} stop seviyesi tetik kârına çok yakın veya üstünde; borsada emir reddi/çok hızlı kapanma riski oluşabilir.`)
        }
      })
      if (!breakEven.enabled && !partialTp.enabled && !trailTp.enabled && (!stepStop.enabled || !steps.length)) {
        warnings.push('K/Z yönetimi kapalı; strateji sadece Edge TP/SL ile çalışır.')
      }
      this.buildHealthAlerts({
        alerts: healthAlerts,
        avgRisk,
        firstProtection,
        singleBotNotional,
        weightedMaxPosition,
        dailyLossGuard,
        steps,
        breakEven,
        partialTp,
        trailTp,
      })

      const aggressiveProtection = firstProtection !== null && firstProtection <= 0.25
      const hasProfitLock = trailTp.enabled || (stepStop.enabled && steps.length > 0)
      return {
        summary,
        metrics,
        timeline,
        warnings,
        healthAlerts,
        modeLabel: aggressiveProtection && hasProfitLock ? 'SL taşıyan aktif yapı' : 'Temel koruma',
        badgeVariant: aggressiveProtection && hasProfitLock ? 'light-success' : 'light-secondary',
      }
    },
    canSave() {
      return this.form && this.form.name && this.form.totalBudget > 0 && this.form.totalBots > 0 && this.form.config.profiles.length
    },
    canApply() {
      if (!this.applyModal.strategy) return false
      if (this.applyForm.mode === 'LIVE' && !this.applyForm.apiKeyId) return false
      return true
    },
  },
  watch: {
    saveStatus(val) {
      if (val.status === true) this.toast('success', 'Başarılı', val.message, 'CheckIcon')
      else if (val.status === false) this.toast('danger', 'Hata', val.message, 'XIcon')
    },
    'form.market': function (val, oldVal) {
      if (!this.form || !val || val === oldVal) return
      this.entryPresetState.autoAppliedPresetKeys = []
      this.refreshStrategyEntryPresets()
    },
    'form.totalBudget': 'onAutoCalcInputChange',
    'form.totalBots': 'onAutoCalcInputChange',
    'form.leverage': 'onAutoCalcInputChange',
    'form.profitTarget': 'onAutoCalcInputChange',
    'form.config.targetSignalPoolEnabled': 'onAutoCalcInputChange',
  },
  created() {
    this.fetchList()
    if (!this.$store.getters['apiKeys/dataList']?.length) {
      this.$store.dispatch('apiKeys/getDataList', {})
    }
  },
  methods: {
    async fetchList() {
      this.loading = true
      const list = await this.$store.dispatch('profitStrategies/getDataList', this.filter)
      this.loading = false
      if (!this.form && list.length) this.selectStrategy(list[0])
    },
    onSearchInput() {
      clearTimeout(this.searchTimer)
      this.searchTimer = setTimeout(() => this.fetchList(), 350)
    },
    selectStrategy(item) {
      this.form = this.normalizeStrategy(item)
      this.pnlHealth = null
      this.pnlAutoTuneSuggestion = null
      this.entryPresetState.autoAppliedPresetKeys = []
      this.fetchPnlHealth()
      this.refreshStrategyEntryPresets()
    },
    newStrategy() {
      const base = this.strategies[0] ? this.normalizeStrategy(this.strategies[0]) : this.defaultForm()
      base.id = null
      base.isDefault = false
      base.name = `${base.name} Kopya`
      this.form = base
      this.pnlHealth = null
      this.pnlAutoTuneSuggestion = null
      this.entryPresetState.autoAppliedPresetKeys = []
      this.refreshStrategyEntryPresets()
    },
    async refreshStrategyEntryPresets() {
      if (!this.form) return
      this.entryPresetState.loading = true
      try {
        const response = await axiosIns.post('/indicators/signal-outcomes/summary', {
          market: this.form.market || 'FUTURES',
          hours: 72,
          limit: 25,
        })
        this.entryPresetState.rows = extractEntryPresetRows(response.data.data || {}, 4)
        this.maybeAutoApplyStrategyEntryPreset()
      } catch {
        this.entryPresetState.rows = []
        this.toast('warning', 'Öneri yok', 'Entry tuning önerileri alınamadı.', 'AlertTriangleIcon')
      } finally {
        this.entryPresetState.loading = false
      }
    },
    onStrategyEntryAutoApplyChange(enabled) {
      if (!enabled) {
        this.entryPresetState.autoAppliedPresetKeys = []
        return
      }
      this.maybeAutoApplyStrategyEntryPreset()
    },
    maybeAutoApplyStrategyEntryPreset() {
      if (!this.entryPresetState.autoApplyEnabled) return
      this.entryPresetState.rows.forEach(row => {
        if (!row?.preset?.id || this.isStrategyEntryPresetApplied(row)) return
        this.applyStrategyEntryPreset(row, { silent: true })
      })
    },
    applyStrategyEntryPreset(row, options = {}) {
      if (!this.form?.config || !row?.preset) return
      applyEntryQualityPreset(this.form.config, row.preset)
      this.form.config.signalEntry = this.normalizeSignalEntry(this.form.config.signalEntry)
      this.form.config.indicatorParams = this.normalizeIndicatorParams(this.form.config.indicatorParams)
      this.form.config.positionManagement = this.normalizePositionManagement(this.form.config.positionManagement)
      const presetKey = this.strategyEntryPresetKey(row)
      if (!this.entryPresetState.autoAppliedPresetKeys.includes(presetKey)) {
        this.entryPresetState.autoAppliedPresetKeys.push(presetKey)
      }
      if (!options.silent) {
        this.toast('success', 'Preset işlendi', `${row.preset.label} draft stratejiye uygulandı. Kaydetmeden kalıcı olmaz.`, 'CheckIcon')
      }
    },
    strategyEntryPresetKey(row) {
      const formKey = this.form?.id || this.form?.name || 'draft'
      return `${formKey}:${row?.preset?.id || ''}`
    },
    isStrategyEntryPresetApplied(row) {
      return this.entryPresetState.autoAppliedPresetKeys.includes(this.strategyEntryPresetKey(row))
    },
    entryPresetVariant(severity) {
      if (severity === 'RISK') return 'light-danger'
      if (severity === 'WATCH') return 'light-warning'
      return 'light-success'
    },
    entryPresetLabel(severity) {
      if (severity === 'RISK') return 'Risk'
      if (severity === 'WATCH') return 'Dikkat'
      return 'Bilgi'
    },
    entryPresetScopeVariant(scope) {
      if (scope === 'GLOBAL_EXPOSURE') return 'light-info'
      if (scope === 'INDICATOR_PARAMS') return 'light-warning'
      return 'light-primary'
    },
    entryPresetScopeLabel(scope) {
      if (scope === 'GLOBAL_EXPOSURE') return 'Exposure'
      if (scope === 'INDICATOR_PARAMS') return 'Engine'
      return 'Signal Entry'
    },
    async saveStrategy() {
      const body = this.buildPayload()
      if (this.form.id) {
        const row = await this.$store.dispatch('profitStrategies/update', { id: this.form.id, body })
        this.selectStrategy(row)
      } else {
        const row = await this.$store.dispatch('profitStrategies/create', body)
        this.selectStrategy(row)
      }
    },
    async removeStrategy() {
      if (!this.form?.id || this.form.isDefault) return
      await this.$store.dispatch('profitStrategies/remove', this.form.id)
      this.form = null
      await this.fetchList()
    },
    openApply(item) {
      const strategy = item.id === this.form?.id ? this.form : this.normalizeStrategy(item)
      this.applyModal = { show: true, strategy }
      this.applyForm = {
        mode: strategy.mode,
        market: strategy.market,
        edgeKind: strategy.edgeKind,
        apiKeyId: null,
        autoStart: false,
        namePrefix: strategy.name,
      }
    },
    async applyStrategy() {
      this.applying = true
      try {
        let { id } = this.applyModal.strategy
        if (!id) {
          this.toast('warning', 'Önce Kaydet', 'Yeni stratejiyi uygulamadan önce kaydetmelisin.', 'AlertTriangleIcon')
          return
        }
        if (this.form?.id === id) {
          const body = this.buildPayload()
          const row = await this.$store.dispatch('profitStrategies/update', { id, body })
          this.selectStrategy(row)
          this.applyModal.strategy = this.normalizeStrategy(row)
          id = row.id
        }
        await this.$store.dispatch('profitStrategies/apply', { id, body: this.applyForm })
      } finally {
        this.applying = false
      }
    },
    async runProfileCheck() {
      if (!this.form) return
      this.profileChecking = true
      try {
        const result = await this.$store.dispatch('profitStrategies/profileCheck', {
          market: this.form.market,
          edgeKind: this.form.edgeKind,
          targetSignalPoolEnabled: this.form.config?.targetSignalPoolEnabled === true,
          totalBudget: Number(this.form.totalBudget) || 0,
          totalBots: Number(this.form.totalBots) || 0,
          leverage: Number(this.form.leverage) || 1,
          tpPerc: Number(this.form.tpPerc) || 0,
          slPerc: Number(this.form.slPerc) || 0,
          config: this.form.config,
        })
        this.profileCheckModal = { show: true, result }
      } finally {
        this.profileChecking = false
      }
    },
    async fetchPnlHealth() {
      if (!this.form || this.pnlHealthLoading) return
      this.pnlHealthLoading = true
      try {
        this.pnlHealth = await this.$store.dispatch('profitStrategies/pnlHealth', {
          market: this.form.market,
          mode: this.form.mode,
          edgeKind: this.form.edgeKind,
          tpPerc: Number(this.form.tpPerc) || undefined,
          slPerc: Number(this.form.slPerc) || undefined,
          sampleLimit: 150,
          lookbackDays: 14,
        })
      } catch {
        this.pnlHealth = null
      } finally {
        this.pnlHealthLoading = false
      }
    },
    async onPnlAutoTuneToggle(value) {
      this.form.config.pnlHealthAutoTune.enabled = !!value
      this.pnlAutoTuneSuggestion = null
      if (value && !this.pnlHealth) {
        await this.fetchPnlHealth()
      }
      if (value && this.pnlHealth) this.generatePnlAutoTuneSuggestion()
    },
    generatePnlAutoTuneSuggestion() {
      if (!this.form?.config?.pnlHealthAutoTune?.enabled) return
      if (!this.pnlHealth?.metrics) {
        this.toast('warning', 'Veri yok', 'Önce K/Z sağlık panelini yenilemelisin.', 'AlertTriangleIcon')
        return
      }
      this.pnlAutoTuneSuggestion = this.buildPnlAutoTuneSuggestion()
    },
    buildPnlAutoTuneSuggestion() {
      const m = this.pnlHealth.metrics || {}
      const coverage = Number(m.coverageRatio || 0)
      const profitFactor = Number(m.profitFactor || 0)
      const expectancy = Number(m.expectancy || 0)
      const avgLoss = Number(m.avgLoss || 0)
      const largestLoss = Number(m.largestLoss || 0)
      const nearSlRate = Number(m.fullOrNearSlRate || 0)
      const recommendation = recommendExitGovernorModeFromPnlHealth(m)
      const { recommendedMode } = recommendation
      const profiles = (this.form.config.profiles || []).map(profile => ({ ...profile }))
      const modeAppliedConfig = applyExitGovernorModePreset({
        ...this.form.config,
        positionGuardian: this.normalizePositionGuardian(this.form.config.positionGuardian),
      }, recommendedMode)
      const pm = JSON.parse(JSON.stringify(modeAppliedConfig.positionManagement || {}))
      const stepStop = JSON.parse(JSON.stringify(modeAppliedConfig.stepStop || {}))
      const positionGuardian = JSON.parse(JSON.stringify(modeAppliedConfig.positionGuardian || {}))
      const pool = this.normalizePoolFilters(this.form.config.targetSignalPoolFilters)
      const changes = []
      const summary = []

      const weakCoverage = coverage > 0 && coverage < 1.1
      const weakPf = profitFactor > 0 && profitFactor < 1.15
      const badExpectancy = expectancy < 0
      const fatTailLoss = avgLoss > 0 && largestLoss > avgLoss * 2
      const nearFullSl = nearSlRate > 35
      const riskCut = badExpectancy ? 0.75 : (weakCoverage || weakPf || fatTailLoss || nearFullSl ? 0.85 : 1)

      changes.push(`Mod: ${exitGovernorModeLabel(recommendedMode)}`)
      summary.push(`Onerilen mod: ${exitGovernorModeLabel(recommendedMode)}`)
      summary.push(recommendation.modeReason)
      if (recommendedMode !== this.exitGovernorMode) {
        changes.push('Mode baseline yeniden ayarlandi')
      } else {
        changes.push('Mevcut mode korunuyor')
      }
      if (weakCoverage) summary.push(`Avg win, gerekli avg win esigini yeterince karsilamiyor (${this.formatNum(coverage * 100, 0)}%).`)

      if (weakPf || badExpectancy || fatTailLoss || nearFullSl) {
        profiles.forEach(profile => {
          profile.riskUsdtPerTrade = this.roundMoney(Math.max(1, Number(profile.riskUsdtPerTrade || 0) * riskCut), 2)
          profile.maxCapitalUsagePercent = this.roundPct(Math.max(5, Number(profile.maxCapitalUsagePercent || 0) * riskCut))
          if (profile.dailyGuard?.enabled) {
            profile.dailyGuard = {
              ...profile.dailyGuard,
              maxDailyLossUsdt: this.roundMoney(Math.max(5, Number(profile.dailyGuard.maxDailyLossUsdt || 0) * riskCut), 0),
              maxConsecutiveLosses: 1,
            }
          }
        })
        changes.push(`Risk ${this.formatNum((1 - riskCut) * 100, 0)}% azaltıldı`)
        summary.push('SL maliyeti kâr tamponuna göre yüksek; risk/max sermaye tarafı daraltıldı.')
      }

      if (this.form.config.targetSignalPoolEnabled && (weakPf || badExpectancy || weakCoverage)) {
        pool.maxEdges = Math.min(Number(pool.maxEdges || 10), 6)
        pool.minScoreFinal = Math.max(Number(pool.minScoreFinal || 0), 0.4)
        pool.minWinRate = Math.max(Number(pool.minWinRate || 0), 62)
        pool.minNetEv = Math.max(Number(pool.minNetEv || 0), 0.06)
        pool.minTrades = Math.max(Number(pool.minTrades || 0), 20)
        pool.symbolCooldownMinutes = Math.max(Number(pool.symbolCooldownMinutes || 0), 75)
        pool.rejectLastExitSl = true
        pool.maxSameSideOpenPositions = 1
        changes.push('Pool filtreleri güvenli moda çekildi')
      }

      if (!changes.length) {
        summary.push('Panel metrikleri kritik bir ayar değişikliği gerektirmiyor.')
        changes.push('Ayar değişikliği önerilmedi')
      }

      return {
        recommendedMode,
        modeReason: recommendation.modeReason,
        summary,
        changes,
        patch: {
          exitGovernor: {
            ...(this.form.config.exitGovernor || {}),
            mode: recommendedMode,
          },
          profiles,
          positionManagement: pm,
          stepStop,
          positionGuardian,
          targetSignalPoolFilters: pool,
        },
      }
    },
    applyPnlAutoTuneSuggestion() {
      const suggestion = this.pnlAutoTuneSuggestion
      if (!suggestion?.patch || !this.form) return
      this.form.config.profiles = suggestion.patch.profiles
      this.form.config.exitGovernor = suggestion.patch.exitGovernor
      this.form.config.positionManagement = suggestion.patch.positionManagement
      this.form.config.stepStop = suggestion.patch.stepStop
      this.form.config.positionGuardian = this.normalizePositionGuardian(suggestion.patch.positionGuardian)
      if (this.form.config.targetSignalPoolEnabled) {
        this.form.config.targetSignalPoolFilters = this.normalizePoolFilters(suggestion.patch.targetSignalPoolFilters)
      }
      this.form.config.pnlHealthAutoTune = {
        ...this.normalizePnlHealthAutoTune(this.form.config.pnlHealthAutoTune),
        enabled: true,
        mode: 'SUGGEST_ONLY',
        lastAppliedAt: new Date().toISOString(),
      }
      this.pnlAutoTuneSuggestion = null
      this.toast('success', 'Öneri uygulandı', 'K/Z sağlık önerisi forma işlendi. Kaydetmeden kalıcı olmaz.', 'CheckIcon')
    },
    exitGovernorModeLabel(mode) {
      return exitGovernorModeLabel(mode)
    },
    applyExitGovernorMode(mode) {
      if (!this.form?.config) return
      this.form.config = applyExitGovernorModePreset({
        ...this.form.config,
        positionGuardian: this.normalizePositionGuardian(this.form.config.positionGuardian),
      }, mode)
      this.toast('success', 'Exit modu işlendi', `${exitGovernorModeLabel(mode)} baseline'i draft stratejiye uygulandı.`, 'CheckIcon')
    },
    reapplyExitGovernorMode() {
      this.applyExitGovernorMode(this.exitGovernorMode)
    },
    pnlHealthAlertVariant(severity) {
      if (severity === 'danger') return 'light-danger'
      if (severity === 'warning') return 'light-warning'
      if (severity === 'success') return 'light-success'
      return 'light-info'
    },
    pnlHealthAlertIcon(severity) {
      if (severity === 'danger') return 'AlertOctagonIcon'
      if (severity === 'warning') return 'AlertTriangleIcon'
      if (severity === 'success') return 'CheckCircleIcon'
      return 'InfoIcon'
    },
    applyProfileCheckSuggestion() {
      const { result } = this.profileCheckModal
      if (!result || !this.form) return
      const suggested = result.suggestedConfig || {}
      this.form.config.targetSignalPoolEnabled = suggested.targetSignalPoolEnabled === true
      this.form.config.targetSignalPoolFilters = this.normalizePoolFilters(suggested.targetSignalPoolFilters)
      this.form.config.autoCalculation = this.normalizeAutoCalculation({
        ...this.form.config.autoCalculation,
        ...(suggested.autoCalculation || {}),
        enabled: true,
      })
      this.applyAutoCalculation({
        preserveManual: this.form.config.autoCalculation.preserveManual,
        silent: true,
      })
      this.profileCheckModal.show = false
      this.toast('success', 'Öneri Uygulandı', 'Profil kontrolü önerileri forma işlendi. Kaydetmeden kalıcı olmaz.', 'CheckIcon')
    },
    profileAlertVariant(severity) {
      if (severity === 'danger') return 'light-danger'
      if (severity === 'warning') return 'light-warning'
      if (severity === 'success') return 'light-success'
      return 'light-info'
    },
    profileAlertIcon(severity) {
      if (severity === 'danger') return 'AlertOctagonIcon'
      if (severity === 'warning') return 'AlertTriangleIcon'
      if (severity === 'success') return 'CheckCircleIcon'
      return 'InfoIcon'
    },
    addProfile() {
      this.form.config.profiles.push({
        key: `profile_${this.form.config.profiles.length + 1}`,
        name: 'Yeni Profil',
        budget: 500,
        botCount: 1,
        capitalPerBot: 500,
        riskUsdtPerTrade: 10,
        maxCapitalUsagePercent: 20,
        profitTarget: this.form.profitTarget || 5,
        maxLossLimit: 40,
        dailyGuard: {
          enabled: true, maxDailyLossUsdt: 40, maxConsecutiveLosses: 1, cooldownMinutes: 120,
        },
        dailyProfitGuard: { enabled: false, maxDailyProfitUsdt: 100 },
      })
    },
    removeProfile(index) {
      if (this.form.config.profiles.length <= 1) return
      this.form.config.profiles.splice(index, 1)
    },
    buildPayload() {
      return {
        name: this.form.name,
        description: this.form.description || null,
        isActive: !!this.form.isActive,
        totalBudget: Number(this.form.totalBudget) || 0,
        totalBots: Number(this.form.totalBots) || 0,
        leverage: Number(this.form.leverage) || 1,
        mode: this.form.mode,
        market: this.form.market,
        edgeKind: this.form.edgeKind,
        tpPerc: Number(this.form.tpPerc) || 0,
        slPerc: Number(this.form.slPerc) || 0,
        profitTarget: Number(this.form.profitTarget) || 5,
        profitTargetIsPct: true,
        maxLossLimit: this.form.maxLossLimit || null,
        config: this.form.config,
      }
    },
    normalizeStrategy(row) {
      const base = this.defaultForm()
      const cfg = row.config || {}
      return {
        ...base,
        ...row,
        totalBudget: Number(row.totalBudget) || base.totalBudget,
        totalBots: Number(row.totalBots) || base.totalBots,
        leverage: Number(row.leverage) || base.leverage,
        tpPerc: Number(row.tpPerc) || base.tpPerc,
        slPerc: Number(row.slPerc) || base.slPerc,
        profitTarget: Number(row.profitTarget) || base.profitTarget,
        maxLossLimit: row.maxLossLimit !== null && row.maxLossLimit !== undefined ? Number(row.maxLossLimit) : null,
        config: {
          profiles: (cfg.profiles || base.config.profiles).map(p => ({
            ...p,
            budget: Number(p.budget) || 0,
            botCount: Number(p.botCount) || 1,
            capitalPerBot: Number(p.capitalPerBot) || Math.round((Number(p.budget) || 0) / Math.max(1, Number(p.botCount) || 1)),
            dailyGuard: {
              enabled: true, maxDailyLossUsdt: 40, maxConsecutiveLosses: 1, cooldownMinutes: 120, ...(p.dailyGuard || {}),
            },
            dailyProfitGuard: { enabled: false, maxDailyProfitUsdt: 100, ...(p.dailyProfitGuard || {}) },
          })),
          exitGovernor: {
            ...(cfg.exitGovernor || base.config.exitGovernor),
            mode: resolveExitGovernorMode(cfg.exitGovernor?.mode || base.config.exitGovernor.mode),
          },
          positionManagement: {
            ...base.config.positionManagement,
            ...(cfg.positionManagement || {}),
            breakEven: { ...base.config.positionManagement.breakEven, ...((cfg.positionManagement || {}).breakEven || {}) },
            partialTp: { ...base.config.positionManagement.partialTp, ...((cfg.positionManagement || {}).partialTp || {}) },
            trailTp: { ...base.config.positionManagement.trailTp, ...((cfg.positionManagement || {}).trailTp || {}) },
            riskSizing: { ...base.config.positionManagement.riskSizing, ...((cfg.positionManagement || {}).riskSizing || {}) },
            globalExposure: { ...base.config.positionManagement.globalExposure, ...((cfg.positionManagement || {}).globalExposure || {}) },
          },
          stepStop: { ...base.config.stepStop, ...(cfg.stepStop || {}) },
          targetSignalPoolEnabled: cfg.targetSignalPoolEnabled === true,
          dailyProfitGivebackGuard: this.normalizeDailyProfitGivebackGuard(
            cfg.dailyProfitGivebackGuard || base.config.dailyProfitGivebackGuard,
          ),
          targetSignalPoolFilters: this.normalizePoolFilters(cfg.targetSignalPoolFilters || base.config.targetSignalPoolFilters),
          signalEntry: this.normalizeSignalEntry(cfg.signalEntry || base.config.signalEntry),
          indicatorParams: this.normalizeIndicatorParams(cfg.indicatorParams || base.config.indicatorParams),
          marketDirectionConsensus:
            this.normalizeMarketDirectionConsensus(
              cfg.marketDirectionConsensus || base.config.marketDirectionConsensus,
            ),
          strategySafetyGovernor:
            this.normalizeStrategySafetyGovernor(
              cfg.strategySafetyGovernor || base.config.strategySafetyGovernor,
            ),
          inheritEdgeTpSl: cfg.inheritEdgeTpSl !== false,
          exitOnIndicatorSignal: cfg.exitOnIndicatorSignal !== false,
          positionGuardian: this.normalizePositionGuardian(cfg.positionGuardian || base.config.positionGuardian),
          autoCalculation: this.normalizeAutoCalculation(cfg.autoCalculation || base.config.autoCalculation),
          pnlHealthAutoTune: this.normalizePnlHealthAutoTune(cfg.pnlHealthAutoTune || base.config.pnlHealthAutoTune),
        },
      }
    },
    defaultForm() {
      return {
        id: null,
        name: 'SL Taşıyan 3400 USDT / 30x',
        description: '',
        isDefault: false,
        isActive: true,
        totalBudget: 3400,
        totalBots: 10,
        leverage: 30,
        mode: 'TESTNET',
        market: 'FUTURES',
        edgeKind: 'QUICK_GAIN',
        tpPerc: 1.2,
        slPerc: 0.8,
        profitTarget: 5,
        maxLossLimit: null,
        config: {
          profiles: [
            {
              key: 'low',
              name: 'Düşük',
              budget: 1000,
              botCount: 3,
              capitalPerBot: 333,
              riskUsdtPerTrade: 12,
              maxCapitalUsagePercent: 20,
              profitTarget: 5,
              maxLossLimit: 40,
              dailyGuard: {
                enabled: true, maxDailyLossUsdt: 40, maxConsecutiveLosses: 1, cooldownMinutes: 120,
              },
              dailyProfitGuard: { enabled: false, maxDailyProfitUsdt: 100 },
            },
            {
              key: 'mid',
              name: 'Orta',
              budget: 1600,
              botCount: 5,
              capitalPerBot: 320,
              riskUsdtPerTrade: 20,
              maxCapitalUsagePercent: 30,
              profitTarget: 5,
              maxLossLimit: 80,
              dailyGuard: {
                enabled: true, maxDailyLossUsdt: 80, maxConsecutiveLosses: 1, cooldownMinutes: 120,
              },
              dailyProfitGuard: { enabled: false, maxDailyProfitUsdt: 100 },
            },
            {
              key: 'test',
              name: 'Deneme',
              budget: 800,
              botCount: 2,
              capitalPerBot: 400,
              riskUsdtPerTrade: 30,
              maxCapitalUsagePercent: 40,
              profitTarget: 5,
              maxLossLimit: 60,
              dailyGuard: {
                enabled: true, maxDailyLossUsdt: 60, maxConsecutiveLosses: 1, cooldownMinutes: 180,
              },
              dailyProfitGuard: { enabled: false, maxDailyProfitUsdt: 100 },
            },
          ],
          exitGovernor: {
            mode: 'BALANCED',
          },
          positionManagement: {
            breakEven: {
              enabled: true, triggerProfit: 0.35, bufferProfit: 0.05, includeFees: true, bufferMode: 'NET', slippageBufferPct: 0.05,
            },
            partialTp: {
              enabled: true, atProfit: 0.50, takePercent: 40, moveRemainderToBreakEven: true,
            },
            trailTp: { enabled: true, triggerProfit: 0.65, trailPercent: 0.35 },
            riskSizing: { enabled: true },
            globalExposure: { enabled: true, blockOppositeSide: true, scope: 'GLOBAL' },
          },
          stepStop: {
            enabled: true,
            steps: [
              { atProfit: 0.5, moveStopTo: 0.1 },
              { atProfit: 0.8, moveStopTo: 0.35 },
              { atProfit: 1.1, moveStopTo: 0.65 },
            ],
          },
          targetSignalPoolEnabled: false,
          dailyProfitGivebackGuard: { enabled: false, minProfitToArmUsdt: 0, maxGivebackPercent: 50 },
          targetSignalPoolFilters: {
            maxEdges: 10,
            minScoreFinal: 0.2,
            minWinRate: 55,
            minNetEv: 0.02,
            minTrades: 10,
            minMfeSamples: 5,
            minMfe50Rate: 30,
            minMfe75Rate: 10,
            minAvgMfe: 0.30,
            rejectLastExitSl: true,
            symbolCooldownMinutes: 30,
            maxSameSideOpenPositions: 1,
          },
          signalEntry: {
            confirmationTicks: 1,
            maxSignalAgeBars: 2,
            minFavorableMovePct: 0,
            maxFavorableMovePct: 0.30,
            maxAdverseMovePct: 0.10,
            routerEnabled: true,
            minEntryScore: 0.30,
            minRemainingRewardRisk: 0.45,
            lateSignalPenaltyStartPct: 45,
            familyWeightEnabled: true,
            familyLookback: 50,
            familyMinSamples: 5,
            familyMinWeight: 0.65,
            familyMaxWeight: 1.20,
          },
          indicatorParams: this.defaultIndicatorParams(),
          marketDirectionConsensus: {
            enabled: false,
            minSignals: 5,
            requiredAgreementPercent: 65,
            freshnessBars: 1,
            stabilityChecks: 2,
            insufficientDataAction: 'WAIT',
          },
          strategySafetyGovernor: this.defaultStrategySafetyGovernor(),
          inheritEdgeTpSl: true,
          exitOnIndicatorSignal: true,
          positionGuardian: this.defaultPositionGuardian(),
          autoCalculation: {
            enabled: false,
            riskMode: 'BALANCED',
            preserveManual: true,
          },
          pnlHealthAutoTune: {
            enabled: false,
            mode: 'SUGGEST_ONLY',
            lastAppliedAt: null,
          },
        },
      }
    },
    defaultPnlHealthAutoTune() {
      return { enabled: false, mode: 'SUGGEST_ONLY', lastAppliedAt: null }
    },
    defaultPositionGuardian() {
      return {
        enabled: true,
        authority: 'AUTO_FULL',
        profile: 'BALANCED',
        minMfeToProtect: 0.30,
        maxGivebackPercent: 45,
        softExitAfterMinutes: 45,
        softExitMaxLoss: 0.20,
        profitExitMinPnl: 0.15,
        tightenOnMomentumLoss: true,
        blockSameSideWhileNegative: true,
        coordinateMfeControls: true,
        preMfeDamageControl: true,
        preMfeAfterMinutes: 20,
        preMfeMaxMfe: 0.15,
        preMfeSoftExitLoss: 0.45,
        halfSlSoftExitEnabled: true,
        halfSlSoftExitRatio: 50,
        mfeProgressWatchEnabled: true,
        mfeProgressWatchStart: 0.30,
        mfeProgressWatchMinutes: 15,
        mfeProgressMinBridgePercent: 55,
        mfeProgressMaxLoss: 0.10,
        minNetProfitBuffer: 0.03,
        breakEvenMoveMfe: 0.55,
        profitMoveMfe: 0.75,
        profitMoveMinBuffer: 0.10,
        profitMoveDynamicRatio: 25,
        autoTuneApplyWithoutApproval: false,
        walletAware: true,
        walletPressureDrawdownPct: 0.50,
        walletPressureLossMultiplier: 0.75,
        walletPressureTimeMultiplier: 0.50,
        tpPreservation: true,
        minTpDistanceForProfitClose: 0.25,
        minTpProgressForProfitClose: 50,
        oppositePnlFuseEnabled: false,
        oppositePnlFuseThresholdPct: 0.96,
        avgWinProtectionEnabled: true,
        avgWinLookbackTrades: 30,
        minAvgWinSamples: 3,
        minProfitCloseAvgWinRatio: 70,
        recoveryAssistEnabled: false,
        recoveryAssistMode: 'SUGGEST_ONLY',
        recoverySameSideFailureFlip: true,
        recoveryAllowSameSymbolHedge: false,
        recoveryMinSameSideFailures: 1,
        recoveryWeaknessLossPct: 0.15,
        recoveryWeaknessLookbackBars: 12,
        recoveryMaxRiskPct: 25,
        recoveryCooldownMinutes: 30,
        recoveryMinCandidateScore: 0.20,
        recoveryCandidateLimit: 3,
        lossInsuranceEnabled: false,
        insurancePremiumPercent: 20,
        insuranceDamageRepaymentPercent: 35,
        insuranceReserveTargetPercent: 8,
        insuranceMaxOpenDamageUsdt: 100,
        insuranceDamageRiskReductionPercent: 25,
        insuranceRecoveryRiskCapPercent: 15,
        insuranceMaxRecoveryPerDay: 1,
        closeFollowEnabled: false,
        closeFollowUnrealizedConfidencePct: 60,
        closeFollowEntryPausePct: 50,
        closeFollowLossUsageTriggerPct: 70,
        closeFollowReleasePct: 50,
        closeFollowMinNetProfitUsdt: 5,
        closeFollowWinnerLockPct: 70,
        closeFollowCloseOnPositiveBasket: true,
        closeFollowProtectWinners: true,
        closeFollowPauseRecovery: true,
        closeFollowRequireApproval: false,
        closeFollowMaxClosesPerCycle: 3,
        closeFollowMinPositionAgeMinutes: 2,
      }
    },
    normalizePositionGuardian(value) {
      const d = this.defaultPositionGuardian()
      const v = value || {}
      const profile = ['PROTECTIVE', 'BALANCED', 'AGGRESSIVE'].includes(v.profile) ? v.profile : d.profile
      const authority = ['SUGGEST_CONFIRM', 'AUTO_STOP_ONLY', 'AUTO_FULL'].includes(v.authority) ? v.authority : d.authority
      return {
        ...d,
        ...v,
        enabled: v.enabled !== false,
        authority,
        profile,
        oppositePnlFuseEnabled: v.oppositePnlFuseEnabled === true,
        oppositePnlFuseThresholdPct: Number.isFinite(Number(v.oppositePnlFuseThresholdPct)) ? Number(v.oppositePnlFuseThresholdPct) : d.oppositePnlFuseThresholdPct,
      }
    },
    defaultStrategySafetyGovernor() {
      return {
        enabled: true,
        enforceHiddenRiskCap: true,
        maxRiskUsdtWhenRiskOff: 5,
        maxCapitalUsagePercentWhenRiskOff: 35,
        minNetProfitBufferUsdt: 0.10,
        familyCircuitBreakerEnabled: true,
        familyLookbackTrades: 30,
        familyMinSamples: 5,
        familyMaxLossRate: 0.70,
        familyMinProfitFactor: 0.70,
        guardianLossCircuitBreakerEnabled: true,
        guardianLossLookbackTrades: 12,
        guardianLossMaxCount: 6,
        guardianLossMaxNetUsdt: 60,
        cooldownMinutes: 30,
      }
    },
    normalizeStrategySafetyGovernor(value) {
      const d = this.defaultStrategySafetyGovernor()
      const v = value || {}
      const numberIn = (key, min, max) => {
        const raw = Number(v[key] ?? d[key])
        return Number.isFinite(raw) ? Math.min(max, Math.max(min, raw)) : d[key]
      }
      return {
        enabled: v.enabled !== false,
        enforceHiddenRiskCap: v.enforceHiddenRiskCap !== false,
        maxRiskUsdtWhenRiskOff: numberIn('maxRiskUsdtWhenRiskOff', 0, 1000),
        maxCapitalUsagePercentWhenRiskOff: numberIn('maxCapitalUsagePercentWhenRiskOff', 0, 100),
        minNetProfitBufferUsdt: numberIn('minNetProfitBufferUsdt', 0, 1000),
        familyCircuitBreakerEnabled: v.familyCircuitBreakerEnabled !== false,
        familyLookbackTrades: Math.floor(numberIn('familyLookbackTrades', 5, 500)),
        familyMinSamples: Math.floor(numberIn('familyMinSamples', 0, 100)),
        familyMaxLossRate: numberIn('familyMaxLossRate', 0, 1),
        familyMinProfitFactor: numberIn('familyMinProfitFactor', 0, 10),
        guardianLossCircuitBreakerEnabled: v.guardianLossCircuitBreakerEnabled !== false,
        guardianLossLookbackTrades: Math.floor(numberIn('guardianLossLookbackTrades', 1, 100)),
        guardianLossMaxCount: Math.floor(numberIn('guardianLossMaxCount', 0, 100)),
        guardianLossMaxNetUsdt: numberIn('guardianLossMaxNetUsdt', 0, 10000),
        cooldownMinutes: Math.floor(numberIn('cooldownMinutes', 0, 1440)),
      }
    },
    normalizePnlHealthAutoTune(value) {
      const d = this.defaultPnlHealthAutoTune()
      const v = value || {}
      return {
        enabled: v.enabled !== undefined ? !!v.enabled : d.enabled,
        mode: v.mode === 'SUGGEST_ONLY' ? v.mode : d.mode,
        lastAppliedAt: v.lastAppliedAt || null,
      }
    },
    defaultAutoCalculation() {
      return {
        enabled: false,
        riskMode: 'BALANCED',
        preserveManual: true,
      }
    },
    normalizeAutoCalculation(value) {
      const d = this.defaultAutoCalculation()
      const v = value || {}
      const modes = ['SAFE', 'BALANCED', 'AGGRESSIVE']
      return {
        enabled: v.enabled !== undefined ? !!v.enabled : d.enabled,
        riskMode: modes.includes(v.riskMode) ? v.riskMode : d.riskMode,
        preserveManual: v.preserveManual !== undefined ? !!v.preserveManual : d.preserveManual,
      }
    },
    defaultPoolFilters() {
      return {
        maxEdges: 10,
        minScoreFinal: 0.2,
        minWinRate: 55,
        minNetEv: 0.02,
        minTrades: 10,
        minMfeSamples: 5,
        minMfe50Rate: 30,
        minMfe75Rate: 10,
        minAvgMfe: 0.30,
        rejectLastExitSl: true,
        symbolCooldownMinutes: 30,
        maxSameSideOpenPositions: 1,
      }
    },
    defaultDailyProfitGivebackGuard() {
      return { enabled: false, minProfitToArmUsdt: 0, maxGivebackPercent: 50 }
    },
    defaultSignalEntry() {
      return {
        confirmationTicks: 1,
        maxSignalAgeBars: 2,
        minFavorableMovePct: 0,
        maxFavorableMovePct: 0.30,
        maxAdverseMovePct: 0.10,
        routerEnabled: true,
        minEntryScore: 0.30,
        minRemainingRewardRisk: 0.45,
        lateSignalPenaltyStartPct: 45,
        familyWeightEnabled: true,
        familyLookback: 50,
        familyMinSamples: 5,
        familyMinWeight: 0.65,
        familyMaxWeight: 1.20,
      }
    },
    defaultIndicatorParams() {
      return {}
    },
    normalizeIndicatorParams(value) {
      const v = value && typeof value === 'object' ? value : {}
      const out = { ...v }
      const numberIn = (key, min, max) => {
        const raw = Number(v[key])
        if (!Number.isFinite(raw)) return undefined
        return Math.min(max, Math.max(min, raw))
      }
      if (v.momentumQualityEnabled !== undefined) {
        out.momentumQualityEnabled = v.momentumQualityEnabled === true
      }
      const minBody = numberIn('minMomentumBodyRatio', 0, 1)
      if (minBody !== undefined) out.minMomentumBodyRatio = minBody
      const minClose = numberIn('minMomentumCloseLocation', 0, 1)
      if (minClose !== undefined) out.minMomentumCloseLocation = minClose
      return out
    },
    defaultMarketDirectionConsensus() {
      return {
        enabled: false,
        minSignals: 5,
        requiredAgreementPercent: 65,
        freshnessBars: 1,
        stabilityChecks: 2,
        insufficientDataAction: 'WAIT',
      }
    },
    normalizeMarketDirectionConsensus(value) {
      const d = this.defaultMarketDirectionConsensus()
      const v = value || {}
      const numberIn = (key, min, max) => {
        const raw = Number(v[key] ?? d[key])
        return Number.isFinite(raw) ? Math.min(max, Math.max(min, raw)) : d[key]
      }
      return {
        enabled: v.enabled === true,
        minSignals: Math.floor(numberIn('minSignals', 1, 100)),
        requiredAgreementPercent: numberIn('requiredAgreementPercent', 50, 100),
        freshnessBars: numberIn('freshnessBars', 0.25, 10),
        stabilityChecks: Math.floor(numberIn('stabilityChecks', 1, 10)),
        insufficientDataAction: v.insufficientDataAction === 'ALLOW' ? 'ALLOW' : 'WAIT',
      }
    },
    normalizeSignalEntry(value) {
      const d = this.defaultSignalEntry()
      const v = value || {}
      const numberIn = (key, min, max) => {
        const raw = Number(v[key] ?? d[key])
        if (!Number.isFinite(raw)) return d[key]
        return Math.min(max, Math.max(min, raw))
      }
      return {
        confirmationTicks: Math.floor(numberIn('confirmationTicks', 0, 5)),
        maxSignalAgeBars: Math.floor(numberIn('maxSignalAgeBars', 0, 10)),
        minFavorableMovePct: numberIn('minFavorableMovePct', 0, 5),
        maxFavorableMovePct: numberIn('maxFavorableMovePct', 0, 10),
        maxAdverseMovePct: numberIn('maxAdverseMovePct', 0, 10),
        routerEnabled: v.routerEnabled !== false,
        minEntryScore: numberIn('minEntryScore', 0, 1),
        minRemainingRewardRisk: numberIn('minRemainingRewardRisk', 0, 10),
        lateSignalPenaltyStartPct: numberIn('lateSignalPenaltyStartPct', 0, 100),
        familyWeightEnabled: v.familyWeightEnabled !== false,
        familyLookback: Math.floor(numberIn('familyLookback', 5, 500)),
        familyMinSamples: Math.floor(numberIn('familyMinSamples', 0, 100)),
        familyMinWeight: numberIn('familyMinWeight', 0.1, 2),
        familyMaxWeight: numberIn('familyMaxWeight', 0.1, 3),
      }
    },
    normalizePoolFilters(value) {
      const d = this.defaultPoolFilters()
      const v = value || {}
      const numberOrDefault = (raw, fallback) => {
        const next = Number(raw ?? fallback)
        return Number.isFinite(next) ? next : fallback
      }
      return {
        maxEdges: Math.min(50, Math.max(1, numberOrDefault(v.maxEdges, d.maxEdges))),
        minScoreFinal: numberOrDefault(v.minScoreFinal, d.minScoreFinal),
        minWinRate: Math.min(100, Math.max(0, numberOrDefault(v.minWinRate, d.minWinRate))),
        minNetEv: numberOrDefault(v.minNetEv, d.minNetEv),
        minTrades: Math.max(0, numberOrDefault(v.minTrades, d.minTrades)),
        minMfeSamples: Math.max(0, numberOrDefault(v.minMfeSamples, d.minMfeSamples)),
        minMfe50Rate: Math.min(100, Math.max(0, numberOrDefault(v.minMfe50Rate, d.minMfe50Rate))),
        minMfe75Rate: Math.min(100, Math.max(0, numberOrDefault(v.minMfe75Rate, d.minMfe75Rate))),
        minAvgMfe: Math.max(0, numberOrDefault(v.minAvgMfe, d.minAvgMfe)),
        rejectLastExitSl: v.rejectLastExitSl !== undefined ? !!v.rejectLastExitSl : d.rejectLastExitSl,
        symbolCooldownMinutes: Math.max(0, numberOrDefault(v.symbolCooldownMinutes, d.symbolCooldownMinutes)),
        maxSameSideOpenPositions: Math.max(0, numberOrDefault(v.maxSameSideOpenPositions, d.maxSameSideOpenPositions)),
      }
    },
    normalizeDailyProfitGivebackGuard(value) {
      const d = this.defaultDailyProfitGivebackGuard()
      const v = value || {}
      const minProfit = Number(v.minProfitToArmUsdt ?? d.minProfitToArmUsdt)
      const giveback = Number(v.maxGivebackPercent ?? d.maxGivebackPercent)
      return {
        enabled: v.enabled === true,
        minProfitToArmUsdt: Number.isFinite(minProfit) ? Math.max(0, minProfit) : d.minProfitToArmUsdt,
        maxGivebackPercent: Number.isFinite(giveback) ? Math.min(100, Math.max(0, giveback)) : d.maxGivebackPercent,
      }
    },
    onAutoCalculationToggle(enabled) {
      if (enabled) this.applyAutoCalculation({ preserveManual: false })
    },
    onAutoCalcInputChange() {
      if (!this.form?.config?.autoCalculation?.enabled) return
      this.applyAutoCalculation({ preserveManual: this.form.config.autoCalculation.preserveManual, silent: true })
    },
    applyAutoCalculation(options = {}) {
      if (!this.form) return
      const auto = this.form.config.autoCalculation || this.defaultAutoCalculation()
      const preserveManual = options.preserveManual !== undefined ? options.preserveManual : auto.preserveManual
      const preset = this.autoCalcPreset(auto.riskMode)
      const poolEnabled = this.form.config?.targetSignalPoolEnabled === true
      const totalBudget = Math.max(0, Number(this.form.totalBudget) || 0)
      const totalBots = Math.max(1, Math.floor(Number(this.form.totalBots) || 1))
      const leverage = Math.max(1, Number(this.form.leverage) || 1)
      const profiles = this.buildAutoProfiles(totalBudget, totalBots, preset, poolEnabled)

      this.form.config.profiles = profiles.map(profile => ({
        key: profile.key,
        name: profile.name,
        budget: this.roundMoney(profile.budget, 0),
        botCount: profile.botCount,
        capitalPerBot: this.roundMoney(profile.capitalPerBot, 0),
        riskUsdtPerTrade: this.roundMoney(profile.riskUsdtPerTrade, 2),
        maxCapitalUsagePercent: profile.maxCapitalUsagePercent,
        profitTarget: Number(this.form.profitTarget) || 5,
        maxLossLimit: this.roundMoney(profile.dailyGuard.maxDailyLossUsdt, 0),
        dailyGuard: profile.dailyGuard,
        dailyProfitGuard: profile.dailyProfitGuard,
      }))

      if (!preserveManual) {
        this.form.tpPerc = preset.tp
        this.form.slPerc = preset.sl
        this.form.config.positionManagement = this.buildAutoPositionManagement(preset)
        this.form.config.stepStop = this.buildAutoStepStop(preset)
      }
      if (poolEnabled) {
        this.form.config.positionManagement.globalExposure = { enabled: true, blockOppositeSide: true, scope: 'GLOBAL' }
        this.form.config.targetSignalPoolFilters = this.defensivePoolFilters(auto.riskMode)
      } else {
        this.form.config.targetSignalPoolFilters = this.normalizePoolFilters(this.form.config.targetSignalPoolFilters)
      }

      this.form.config.autoCalculation = {
        enabled: true,
        riskMode: auto.riskMode || 'BALANCED',
        preserveManual: auto.preserveManual !== undefined ? auto.preserveManual : true,
      }

      if (!options.silent) {
        this.toast('success', 'Hesaplandı', `${preset.label} moda göre strateji değerleri güncellendi.`, 'SlidersIcon')
      }
      return {
        totalBudget, totalBots, leverage, preset, poolEnabled,
      }
    },
    autoCalcPreset(mode) {
      const presets = {
        SAFE: {
          label: 'Güvenli',
          riskPct: 0.0035,
          tp: 1.0,
          sl: 0.7,
          maxCapital: [20, 25, 30],
          dailyLossPct: [0.02, 0.025, 0.03],
          beRatio: 0.25,
          partialRatio: 0.4,
          partialTake: 35,
          trailRatio: 0.5,
          trailSlRatio: 0.35,
          cooldown: [120, 120, 180],
          poolRiskMultiplier: 0.9,
          poolCooldownAdd: 15,
        },
        BALANCED: {
          label: 'Dengeli',
          riskPct: 0.006,
          tp: 1.2,
          sl: 0.8,
          maxCapital: [20, 30, 40],
          dailyLossPct: [0.02, 0.03, 0.04],
          beRatio: 0.25,
          partialRatio: 0.4,
          partialTake: 30,
          trailRatio: 0.5,
          trailSlRatio: 0.4,
          cooldown: [120, 120, 180],
          poolRiskMultiplier: 0.85,
          poolCooldownAdd: 30,
        },
        AGGRESSIVE: {
          label: 'Agresif',
          riskPct: 0.009,
          tp: 1.4,
          sl: 0.9,
          maxCapital: [25, 35, 45],
          dailyLossPct: [0.025, 0.04, 0.05],
          beRatio: 0.3,
          partialRatio: 0.45,
          partialTake: 25,
          trailRatio: 0.55,
          trailSlRatio: 0.45,
          cooldown: [120, 150, 180],
          poolRiskMultiplier: 0.8,
          poolCooldownAdd: 45,
        },
      }
      return presets[mode] || presets.BALANCED
    },
    buildAutoProfiles(totalBudget, totalBots, preset, poolEnabled = false) {
      const parts = this.profileParts(totalBots)
      const riskFactors = [0.8, 1, 1.25]
      const poolRiskMultiplier = poolEnabled ? preset.poolRiskMultiplier : 1
      const baseRisk = totalBudget * preset.riskPct * poolRiskMultiplier
      return parts.map((part, idx) => {
        const budget = totalBudget * part.budgetPct
        const { botCount } = part
        const capitalPerBot = budget / Math.max(1, botCount)
        const riskUsdtPerTrade = Math.max(1, baseRisk * riskFactors[idx])
        const maxDailyLossUsdt = Math.max(
          riskUsdtPerTrade * 2,
          budget * preset.dailyLossPct[idx],
        )
        return {
          key: part.key,
          name: part.name,
          budget,
          botCount,
          capitalPerBot,
          riskUsdtPerTrade,
          maxCapitalUsagePercent: preset.maxCapital[idx],
          dailyGuard: {
            enabled: true,
            maxDailyLossUsdt: this.roundMoney(maxDailyLossUsdt, 0),
            maxConsecutiveLosses: 1,
            cooldownMinutes: preset.cooldown[idx] + (poolEnabled ? preset.poolCooldownAdd : 0),
          },
          dailyProfitGuard: {
            enabled: false,
            maxDailyProfitUsdt: this.roundMoney(Math.max(riskUsdtPerTrade * 3, budget * ((Number(this.form.profitTarget) || 5) / 100)), 0),
          },
        }
      })
    },
    profileParts(totalBots) {
      if (totalBots <= 1) {
        return [{
          key: 'low', name: 'Düşük', budgetPct: 1, botCount: 1,
        }]
      }
      if (totalBots === 2) {
        return [
          {
            key: 'low', name: 'Düşük', budgetPct: 0.5, botCount: 1,
          },
          {
            key: 'mid', name: 'Orta', budgetPct: 0.5, botCount: 1,
          },
        ]
      }
      const lowBots = Math.max(1, Math.round(totalBots * 0.3))
      const testBots = Math.max(1, Math.round(totalBots * 0.2))
      const midBots = Math.max(1, totalBots - lowBots - testBots)
      const adjustedTestBots = totalBots - lowBots - midBots
      return [
        {
          key: 'low', name: 'Düşük', budgetPct: 0.3, botCount: lowBots,
        },
        {
          key: 'mid', name: 'Orta', budgetPct: 0.5, botCount: midBots,
        },
        {
          key: 'test', name: 'Deneme', budgetPct: 0.2, botCount: Math.max(1, adjustedTestBots),
        },
      ]
    },
    buildAutoPositionManagement(preset) {
      const tp = Number(preset.tp) || 1
      const sl = Number(preset.sl) || 0.8
      return {
        ...this.form.config.positionManagement,
        breakEven: {
          enabled: true,
          triggerProfit: this.roundPct(this.clamp(tp * preset.beRatio, 0.2, 0.45)),
          bufferProfit: this.roundPct(preset.riskPct >= 0.009 ? 0.05 : 0.03),
          includeFees: true,
          bufferMode: 'NET',
          slippageBufferPct: 0.05,
        },
        partialTp: {
          enabled: true,
          atProfit: this.roundPct(this.clamp(tp * preset.partialRatio, 0.35, 0.7)),
          takePercent: preset.partialTake,
          moveRemainderToBreakEven: true,
        },
        trailTp: {
          enabled: true,
          triggerProfit: this.roundPct(this.clamp(tp * preset.trailRatio, 0.45, 0.85)),
          trailPercent: this.roundPct(this.clamp(sl * preset.trailSlRatio, 0.25, 0.5)),
        },
        globalExposure: { enabled: true, blockOppositeSide: true, scope: 'GLOBAL' },
      }
    },
    buildAutoStepStop(preset) {
      const tp = Number(preset.tp) || 1
      return {
        enabled: true,
        steps: [
          { atProfit: this.roundPct(tp * 0.25), moveStopTo: 0.03 },
          { atProfit: this.roundPct(tp * 0.45), moveStopTo: this.roundPct(tp * 0.15) },
          { atProfit: this.roundPct(tp * 0.7), moveStopTo: this.roundPct(tp * 0.35) },
          { atProfit: this.roundPct(tp * 0.9), moveStopTo: this.roundPct(tp * 0.55) },
        ],
      }
    },
    defensivePoolFilters(mode) {
      const base = {
        SAFE: {
          maxEdges: 8, minScoreFinal: 0.35, minWinRate: 60, minNetEv: 0.05, minTrades: 15, minMfeSamples: 5, minMfe50Rate: 30, minMfe75Rate: 10, minAvgMfe: 0.30, symbolCooldownMinutes: 45,
        },
        BALANCED: {
          maxEdges: 8, minScoreFinal: 0.35, minWinRate: 60, minNetEv: 0.05, minTrades: 15, minMfeSamples: 5, minMfe50Rate: 30, minMfe75Rate: 10, minAvgMfe: 0.30, symbolCooldownMinutes: 60,
        },
        AGGRESSIVE: {
          maxEdges: 6, minScoreFinal: 0.4, minWinRate: 62, minNetEv: 0.06, minTrades: 20, minMfeSamples: 5, minMfe50Rate: 35, minMfe75Rate: 15, minAvgMfe: 0.35, symbolCooldownMinutes: 75,
        },
      }[mode] || {
        maxEdges: 8, minScoreFinal: 0.35, minWinRate: 60, minNetEv: 0.05, minTrades: 15, minMfeSamples: 5, minMfe50Rate: 30, minMfe75Rate: 10, minAvgMfe: 0.30, symbolCooldownMinutes: 60,
      }
      return this.normalizePoolFilters({
        ...base,
        rejectLastExitSl: true,
        maxSameSideOpenPositions: 1,
      })
    },
    buildHealthAlerts({
      alerts, avgRisk, firstProtection, singleBotNotional, dailyLossGuard, steps, breakEven, partialTp, trailTp,
    }) {
      const totalBudget = Number(this.form.totalBudget) || 0
      const avgCapital = this.profileBotTotal > 0 ? this.profileBudgetTotal / this.profileBotTotal : 0
      const tp = Number(this.form.tpPerc) || 0
      const sl = Number(this.form.slPerc) || 0
      const leverage = Number(this.form.leverage) || 1
      const pm = this.form.config?.positionManagement || {}
      const partial = pm.partialTp || {}
      const trail = pm.trailTp || {}
      const riskBudgetPct = totalBudget > 0 ? (avgRisk / totalBudget) * 100 : 0
      const riskCapitalPct = avgCapital > 0 ? (avgRisk / avgCapital) * 100 : 0
      const dailyGuardPct = totalBudget > 0 ? (dailyLossGuard / totalBudget) * 100 : 0
      const rr = sl > 0 ? tp / sl : 0
      const tpUsdt = singleBotNotional * (tp / 100)
      const slUsdt = singleBotNotional * (sl / 100)
      const add = (variant, icon, message) => alerts.push({ variant, icon, message })
      const poolEnabled = this.form.config?.targetSignalPoolEnabled === true
      const pool = this.normalizePoolFilters(this.form.config?.targetSignalPoolFilters)
      const auto = this.form.config?.autoCalculation || {}

      if (rr > 0 && rr < 1) add('light-danger', 'AlertOctagonIcon', `TP/SL oranı ${this.formatNum(rr, 2)}; ödül riskten düşük.`)
      else if (rr > 0 && rr < 1.2) add('light-warning', 'AlertTriangleIcon', `TP/SL oranı ${this.formatNum(rr, 2)}; yüksek win-rate yoksa zayıf kalabilir.`)
      if (sl > 0 && sl < 0.35) add('light-danger', 'AlertOctagonIcon', `SL ${this.formatNum(sl, 2)}%; normal volatiliteye göre çok dar olabilir.`)
      else if (sl > 0 && sl < 0.5) add('light-warning', 'AlertTriangleIcon', `SL ${this.formatNum(sl, 2)}%; pozisyonlar erken kapanabilir.`)
      if (tp > 0 && tp < 0.5) add('light-warning', 'AlertTriangleIcon', `TP ${this.formatNum(tp, 2)}%; komisyon/slippage sonrası net avantaj daralabilir.`)
      if (riskBudgetPct > 2) add('light-danger', 'AlertOctagonIcon', `Bot başı ortalama risk toplam bütçenin %${this.formatNum(riskBudgetPct, 2)} seviyesinde; bu agresif.`)
      else if (riskBudgetPct > 1) add('light-warning', 'AlertTriangleIcon', `Bot başı ortalama risk toplam bütçenin %${this.formatNum(riskBudgetPct, 2)} üstünde.`)
      if (riskCapitalPct > 12) add('light-danger', 'AlertOctagonIcon', `Risk bot başı sermayenin %${this.formatNum(riskCapitalPct, 1)} seviyesinde; çok yüksek.`)
      else if (riskCapitalPct > 8) add('light-warning', 'AlertTriangleIcon', `Risk bot başı sermayenin %${this.formatNum(riskCapitalPct, 1)} seviyesinde.`)
      if (dailyGuardPct > 8) add('light-danger', 'AlertOctagonIcon', `Günlük zarar freni toplam bütçenin %${this.formatNum(dailyGuardPct, 1)} seviyesinde; çok geniş.`)
      else if (dailyGuardPct > 4) add('light-warning', 'AlertTriangleIcon', `Günlük zarar freni toplam bütçenin %${this.formatNum(dailyGuardPct, 1)} seviyesinde.`)
      if (leverage > 50) add('light-danger', 'AlertOctagonIcon', `${this.formatNum(leverage, 0)}x kaldıraç çok yüksek risk üretir.`)
      else if (leverage > 30) add('light-warning', 'AlertTriangleIcon', `${this.formatNum(leverage, 0)}x kaldıraçta max sermaye oranlarını düşük tutmak gerekir.`)
      if (partial.enabled && Number(partial.takePercent) > 95) add('light-danger', 'AlertOctagonIcon', 'Partial TP kapatma oranı %95 üstünde olamaz.')
      if (trail.enabled && Number(trail.trailPercent) > 0 && Number(trail.trailPercent) < 0.2) add('light-warning', 'AlertTriangleIcon', 'Trail aralığı 0.20% altında; kalan pozisyon erken kapanabilir.')
      if (firstProtection !== null && tp > 0 && firstProtection >= tp) add('light-warning', 'AlertTriangleIcon', 'İlk koruma Edge TP seviyesine çok yakın; çoğu işlemde koruma devreye geçmeyebilir.')
      steps.forEach((step, idx) => {
        if (idx > 0 && step.atProfit <= steps[idx - 1].atProfit) add('light-danger', 'AlertOctagonIcon', `Step ${idx + 1} sırası önceki kademe ile uyumsuz.`)
      })
      if (avgCapital > 0 && avgCapital < 50) add('light-warning', 'AlertTriangleIcon', `Bot başı ortalama sermaye ${this.formatNum(avgCapital, 0)} USDT; emir/komisyon etkisi artabilir.`)
      if (poolEnabled) {
        add('light-info', 'InfoIcon', 'Pool mod açık: bot sabit edge ritmini beklemez, aktif edge havuzundaki uygun sinyale daha hızlı atlayabilir.')
        add('light-warning', 'AlertTriangleIcon', 'Pool mod işlem frekansını artırabilir; filtreler gevşekse daha fazla zayıf sinyal ve korele giriş oluşabilir.')
        if (auto.riskMode === 'AGGRESSIVE') add('light-danger', 'AlertOctagonIcon', 'Pool mod + agresif risk birlikte açık; hız ve zarar büyüme riski aynı anda artar.')
        if (pool.maxEdges > 10) add('light-warning', 'AlertTriangleIcon', `Pool max edge ${pool.maxEdges}; havuz genişledikçe ilk gelen sinyal en kaliteli sinyal olmayabilir.`)
        if (pool.minScoreFinal < 0.3) add('light-warning', 'AlertTriangleIcon', `Pool min score ${this.formatNum(pool.minScoreFinal, 2)}; pool modda 0.35+ daha sağlıklı olur.`)
        if (pool.minWinRate < 58) add('light-warning', 'AlertTriangleIcon', `Pool min WR %${this.formatNum(pool.minWinRate, 0)}; pool modda 60+ tercih edilmeli.`)
        if (pool.minNetEv <= 0) add('light-danger', 'AlertOctagonIcon', 'Pool min net EV sıfır veya altında; negatif/kalitesiz edge sinyalleri havuza girebilir.')
        else if (pool.minNetEv < 0.05) add('light-warning', 'AlertTriangleIcon', `Pool min net EV ${this.formatNum(pool.minNetEv, 2)}; pool modda 0.05+ daha güvenli olur.`)
        if (pool.minTrades < 10) add('light-warning', 'AlertTriangleIcon', `Pool min trade ${pool.minTrades}; düşük örneklemli edge'ler havuza girebilir.`)
        if (pool.minMfeSamples <= 0) add('light-warning', 'AlertTriangleIcon', 'Pool MFE filtresi örnek sayısı 0; geçmiş MFE kalitesi elemesi devre dışı kalır.')
        if (pool.minMfe50Rate < 25) add('light-warning', 'AlertTriangleIcon', `+0,50 MFE filtresi %${this.formatNum(pool.minMfe50Rate, 0)}; pool modda 30+ daha seçici olur.`)
        if (pool.minMfe75Rate < 10) add('light-info', 'InfoIcon', `+0,75 MFE filtresi %${this.formatNum(pool.minMfe75Rate, 0)}; avg win büyütmek için 10-15 bandı daha anlamlıdır.`)
        if (pool.minAvgMfe < 0.25) add('light-warning', 'AlertTriangleIcon', `Avg MFE ${this.formatNum(pool.minAvgMfe, 2)}%; sığ hareket üreten edge'ler pool'a girebilir.`)
        if (!pool.rejectLastExitSl) add('light-danger', 'AlertOctagonIcon', 'Pool filtresinde son işlem SL ise alma kapalı; son hareketi SL olan coin tekrar denenebilir.')
        if (pool.symbolCooldownMinutes < 30) add('light-warning', 'AlertTriangleIcon', `Coin cooldown ${pool.symbolCooldownMinutes} dk; aynı coin kısa sürede tekrar tekrar denenebilir.`)
        if (pool.maxSameSideOpenPositions > 1) add('light-danger', 'AlertOctagonIcon', 'Aynı yönde max açık pozisyon 1 üstünde; pool modda aynı yöne yığılma oluşabilir.')
        if (!pm.globalExposure?.enabled) add('light-danger', 'AlertOctagonIcon', 'Aynı coin kilidi kapalı; pool modda korele ve tekrarlı giriş riski artar.')
        if (breakEven?.enabled && Number(breakEven.triggerProfit) > 0.45) add('light-warning', 'AlertTriangleIcon', 'Pool modda break-even geç çalışıyor; düşük MFE üreten sinyaller kârı koruyamadan dönebilir.')
        if (partialTp?.enabled && Number(partialTp.atProfit) > 0.7) add('light-warning', 'AlertTriangleIcon', 'Pool modda partial TP yüksek; zayıf MFE sinyaller full dönüşte kâr bırakmayabilir.')
        if (trailTp?.enabled && Number(trailTp.triggerProfit) > 0.85) add('light-warning', 'AlertTriangleIcon', 'Pool modda trail trigger yüksek; hızlı ama sığ hareketlerde profit lock devreye girmeyebilir.')
      }
      if (!alerts.length && tpUsdt > 0 && slUsdt > 0) {
        add('light-success', 'CheckCircleIcon', `Strateji sağlığı uygun görünüyor: tek bot TP ≈ +${this.formatNum(tpUsdt, 2)} USDT, SL ≈ -${this.formatNum(slUsdt, 2)} USDT.`)
      }
    },
    clamp(value, min, max) {
      return Math.min(max, Math.max(min, Number(value) || 0))
    },
    roundPct(value) {
      return Number((Number(value) || 0).toFixed(2))
    },
    roundMoney(value, digits = 2) {
      return Number((Number(value) || 0).toFixed(digits))
    },
    formatNum(v, d = 2) {
      const n = Number(v)
      return Number.isFinite(n) ? n.toFixed(d) : '-'
    },
    formatMoney(v, d = 2) {
      const n = Number(v)
      if (!Number.isFinite(n)) return '-'
      return `${n.toFixed(d)} USDT`
    },
    formatSignedMoney(v, d = 2) {
      const n = Number(v)
      if (!Number.isFinite(n)) return '-'
      const sign = n >= 0 ? '+' : '-'
      return `${sign}${Math.abs(n).toFixed(d)} USDT`
    },
    toast(variant, title, text, icon) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title, text, icon, variant,
        },
      })
    },
  },
}
</script>

<style scoped>
.strategy-insight {
  color: #5e5873;
}

.auto-calc-panel {
  border: 1px solid #ebe9f1;
  border-radius: 8px;
  padding: 1rem;
  background: #fafbfc;
}

.insight-panel {
  border: 1px solid #ebe9f1;
  border-radius: 8px;
  padding: 1rem;
  background: #fff;
}

.insight-title {
  display: flex;
  align-items: center;
  font-weight: 600;
  margin-bottom: .75rem;
}

.insight-list {
  padding-left: 1rem;
}

.insight-list li {
  margin-bottom: .5rem;
  line-height: 1.35;
}

.metric-row {
  display: flex;
  justify-content: space-between;
  gap: .75rem;
  padding: .35rem 0;
  border-bottom: 1px solid #f3f2f7;
}

.metric-row:last-child {
  border-bottom: 0;
}

.metric-row span {
  color: #6e6b7b;
}

.metric-row strong {
  text-align: right;
  white-space: nowrap;
}

.pnl-health-panel {
  border: 1px solid #ebe9f1;
  border-radius: 8px;
  padding: 1rem;
  background: #fff;
}

.pnl-tune-control {
  border: 1px solid #e7e7f2;
  border-radius: 8px;
  padding: .85rem 1rem;
  background: #fbfbfe;
}

.exit-governor-panel {
  border: 1px solid #ebe9f1;
  border-radius: 8px;
  padding: 1rem;
  background: #fff;
}

.pnl-metric {
  min-height: 72px;
  border: 1px solid #f0eef7;
  border-radius: 8px;
  padding: .75rem;
  background: #fafafe;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.pnl-metric span {
  color: #6e6b7b;
  font-size: .78rem;
}

.pnl-metric strong {
  color: #5e5873;
  font-size: 1rem;
  overflow-wrap: anywhere;
}

.pnl-health-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
}

.timeline {
  display: flex;
  flex-direction: column;
  gap: .5rem;
}

.timeline-item {
  display: grid;
  grid-template-columns: 12px minmax(64px, 82px) minmax(92px, 1fr) minmax(130px, auto);
  align-items: center;
  gap: .5rem;
  min-width: 0;
}

.timeline-dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #7367f0;
}

.timeline-dot.success {
  background: #28c76f;
}

.timeline-dot.warning {
  background: #ff9f43;
}

.timeline-dot.danger {
  background: #ea5455;
}

.timeline-dot.info {
  background: #00cfe8;
}

.timeline-level {
  font-weight: 600;
  white-space: nowrap;
}

.timeline-label {
  min-width: 0;
  overflow-wrap: anywhere;
}

.timeline-usdt {
  color: #6e6b7b;
  font-size: .78rem;
  text-align: right;
  white-space: nowrap;
}

@media (max-width: 575px) {
  .pnl-health-grid {
    grid-template-columns: 1fr;
  }

  .timeline-item {
    grid-template-columns: 12px minmax(64px, 82px) 1fr;
  }

  .timeline-usdt {
    grid-column: 3;
    text-align: left;
    white-space: normal;
  }
}
</style>
